var _path, _path2, _path3, _g, _path4, _path5, _path6, _g2, _path7, _path8, _path9, _g3, _path0, _path1, _path10, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _path11, _g1, _path12, _g10, _path13, _g11, _path14, _g12, _path15, _g13, _path16, _mask, _path17, _path18, _mask2, _path19, _path20, _mask3, _path21, _path22, _mask4, _path23, _path24, _mask5, _path25, _path26, _g14, _g15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChunk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 636,
    height: 588,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2012_6)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -41,
    y: -15,
    width: 388,
    height: 286
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.052 93.133c0 29.145-19.27 52.772-43.041 52.772-23.77 0-172.288-102.224-172.288-131.369 0-29.145 213.391 10.979 237.162 10.979 23.771 0-21.833 38.472-21.833 67.618z",
    fill: "url(#paint0_linear_2012_6)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.769 218.023c0 29.145-19.27 52.772-43.041 52.772-23.77 0-156.195-6.794-156.195-35.939s9.789-98.183 33.56-98.183c23.77 0 165.676 52.205 165.676 81.35z",
    fill: "url(#paint1_radial_2012_6)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M240.595 93.212c64.138 57.928 34.51 28.817 89.599 27.351 8.642 1.664 23.313 1.743 12.86-11.258-13.065-16.252-8.854-27.73-25.183-45.437-16.329-17.707-26.273-35.696-50.924-63.857-24.652-28.162-26.548-4.948-54.34-7.148-27.792-2.2-15.116 1.294-53.461 42.155-38.345 40.861 17.311.266 81.449 58.194zm-60.553 91.118c-85.833 10.105-44.414 6.986-79.595 49.403-6.945 5.406-16.667 16.393 0 17.092 20.834.873 26.698 11.602 50.776 10.978 24.078-.623 44.164 3.743 81.591 3.743 37.427 0 21.208-16.717 41.169-36.179 19.962-19.462 8.983-12.226 3.494-67.993-5.49-55.766-11.603 12.85-97.435 22.956z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#546FFF",
    strokeOpacity: 0.09,
    strokeWidth: 0.25,
    d: "M18.609 153.64h299.167M18.609 217.515h299.167M18.609 89.765h299.167M18.609 25.889h299.167M18.609 249.453h299.167M18.609 121.701h299.167M18.609 185.576h299.167M18.609 57.826h299.167M18.609 265.421h299.167M18.609 137.67h299.167M18.609 201.546h299.167M18.609 73.795h299.167M18.609 9.92h299.167M18.609 233.484h299.167M18.609 105.733h299.167M18.609 169.609h299.167M18.609 41.858h299.167"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#546FFF",
    strokeOpacity: 0.09,
    strokeWidth: 1.261,
    d: "M107.583 171.963V1339.37M268.955 171.963V1339.37M188.271 171.963V1339.37"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    fill: "#546FFF"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.36,
    d: "M187.666 185.566h15.878v15.878h-15.878z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.25,
    d: "M107.82 185.566h15.878v15.878H107.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.11,
    d: "M251.631 73.965h15.878v15.651h-15.878z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.31,
    d: "M123.699 58.088h15.878v15.651h-15.878z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.11,
    d: "M235.525 89.844h15.878v15.651h-15.878z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.31,
    d: "M107.594 73.965h15.878v15.651h-15.878z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.11,
    d: "M235.525 73.965h15.878v15.651h-15.878z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.31,
    d: "M107.594 58.088h15.878v15.651h-15.878z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.25,
    d: "M91.943 185.566h15.878v15.878H91.943z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.25,
    d: "M91.943 201.444h15.878v16.105H91.943zm-31.984-31.756h15.878v15.878H59.959z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.61,
    d: "M219.648 41.982h15.878V57.86h-15.878zm-15.877-18.147h15.878v15.878h-15.878zm-.175 17.92h15.878V57.86h-15.878z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M59.959 57.634h16.105v16.332H59.959zM43.853 41.755h16.105v15.878H43.853z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M27.977 41.982h16.105V57.86H27.977z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M43.853 57.634h16.105v16.332H43.853z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.82 25.877h16.105v15.878H107.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M59.959 89.616h15.878v16.105H59.959z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.26,
    d: "M251.631 169.688h15.878v15.878h-15.878zm15.877 15.878h15.878v15.878h-15.878z"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 345,
    y: 323,
    width: 388,
    height: 286
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M561.052 431.133c0 29.145-19.27 52.772-43.041 52.772-23.77 0-172.288-102.224-172.288-131.369 0-29.145 213.391 10.979 237.162 10.979 23.771 0-21.833 38.472-21.833 67.618z",
    fill: "url(#paint2_linear_2012_6)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M577.769 556.023c0 29.145-19.27 52.772-43.041 52.772-23.77 0-156.195-6.794-156.195-35.939s9.789-98.183 33.56-98.183 165.676 52.205 165.676 81.35z",
    fill: "url(#paint3_radial_2012_6)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M626.595 431.212c64.138 57.928 34.51 28.817 89.599 27.351 8.642 1.664 23.313 1.743 12.86-11.258-13.065-16.252-8.854-27.731-25.183-45.437-16.329-17.706-26.273-35.696-50.924-63.857-24.652-28.162-26.548-4.948-54.34-7.148-27.792-2.201-15.116 1.294-53.461 42.155-38.345 40.861 17.311.266 81.449 58.194zm-60.553 91.118c-85.833 10.105-44.414 6.986-79.595 49.403-6.945 5.406-16.667 16.393 0 17.092 20.834.873 26.698 11.602 50.776 10.978 24.078-.623 44.164 3.743 81.591 3.743 37.427 0 21.208-16.717 41.169-36.179 19.962-19.462 8.983-12.226 3.494-67.993-5.49-55.766-11.603 12.85-97.435 22.956z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#546FFF",
    strokeOpacity: 0.09,
    strokeWidth: 0.25,
    d: "M404.609 491.64h299.167m-299.167 63.875h299.167m-299.167-127.75h299.167m-299.167-63.876h299.167M404.609 587.453h299.167M404.609 459.701h299.167m-299.167 63.875h299.167m-299.167-127.75h299.167m-299.167-63.875h299.167M404.609 475.67h299.167m-299.167 63.876h299.167M404.609 411.795h299.167M404.609 347.92h299.167M404.609 571.484h299.167M404.609 443.733h299.167m-299.167 63.876h299.167M404.609 379.858h299.167"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#546FFF",
    strokeOpacity: 0.09,
    strokeWidth: 1.261,
    d: "M493.583 509.963V1677.37m80.688-1167.407V1677.37"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    fill: "#546FFF"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.36,
    d: "M573.666 523.566h15.878v15.878h-15.878z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.25,
    d: "M493.82 523.566h15.878v15.878H493.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.31,
    d: "M509.699 396.088h15.878v15.651h-15.878z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.11,
    d: "M621.525 427.844h15.878v15.651h-15.878z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.31,
    d: "M493.594 411.965h15.878v15.651h-15.878z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.11,
    d: "M621.525 411.965h15.878v15.651h-15.878z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.31,
    d: "M493.594 396.088h15.878v15.651h-15.878z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.25,
    d: "M477.943 523.566h15.878v15.878h-15.878z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.25,
    d: "M477.943 539.444h15.878v16.105h-15.878zm-31.984-31.756h15.878v15.878h-15.878z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.61,
    d: "M605.648 379.982h15.878v15.878h-15.878zm-15.877-18.147h15.878v15.878h-15.878zm-.175 17.92h15.878v16.105h-15.878z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M445.959 395.634h16.105v16.332h-16.105zm-16.105-15.879h16.105v15.878h-16.105z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M413.977 379.982h16.105v15.878h-16.105z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M429.854 395.634h16.105v16.332h-16.105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.82 363.877h16.105v15.878H493.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M445.959 427.616h15.878v16.105h-15.878z"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 415,
    y: -6,
    width: 388,
    height: 286
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M631.052 102.133c0 29.145-19.27 52.772-43.041 52.772-23.77 0-172.288-102.224-172.288-131.369 0-29.145 213.391 10.979 237.162 10.979 23.771 0-21.833 38.472-21.833 67.618z",
    fill: "url(#paint4_linear_2012_6)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M647.769 227.023c0 29.145-19.27 52.772-43.041 52.772-23.77 0-156.195-6.794-156.195-35.939s9.789-98.183 33.56-98.183 165.676 52.205 165.676 81.35z",
    fill: "url(#paint5_radial_2012_6)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M696.595 102.212c64.138 57.928 34.51 28.817 89.599 27.351 8.642 1.664 23.313 1.743 12.86-11.258-13.065-16.252-8.854-27.73-25.183-45.437-16.329-17.706-26.273-35.696-50.924-63.857-24.652-28.162-26.548-4.948-54.34-7.148-27.792-2.2-15.116 1.294-53.461 42.155-38.345 40.861 17.311.266 81.449 58.194zm-60.553 91.118c-85.833 10.105-44.414 6.986-79.595 49.403-6.945 5.406-16.667 16.393 0 17.092 20.834.873 26.698 11.602 50.776 10.978 24.078-.623 44.164 3.743 81.591 3.743 37.427 0 21.208-16.717 41.169-36.179 19.962-19.462 8.983-12.226 3.494-67.993-5.49-55.766-11.603 12.85-97.435 22.956z",
    fill: "#D9D9D9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#546FFF",
    strokeOpacity: 0.09,
    strokeWidth: 0.25,
    d: "M474.609 162.64h299.167m-299.167 63.875h299.167M474.609 98.765h299.167M474.609 34.889h299.167M474.609 258.453h299.167M474.609 130.701h299.167m-299.167 63.875h299.167M474.609 66.826h299.167M474.609 2.951h299.167m-299.167 271.47h299.167M474.609 146.67h299.167m-299.167 63.876h299.167M474.609 82.795h299.167M474.609 18.92h299.167M474.609 242.484h299.167M474.609 114.733h299.167m-299.167 63.876h299.167M474.609 50.858h299.167"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#546FFF",
    strokeOpacity: 0.09,
    strokeWidth: 1.261,
    d: "M563.583 180.963V1348.37"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    fill: "#546FFF"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.25,
    d: "M563.82 194.566h15.878v15.878H563.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.31,
    d: "M579.699 67.088h15.878v15.651h-15.878zm-16.105 15.877h15.878v15.651h-15.878zm0-15.877h15.878v15.651h-15.878z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.25,
    d: "M547.943 194.566h15.878v15.878h-15.878z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.25,
    d: "M547.943 210.444h15.878v16.105h-15.878zm-31.984-31.756h15.878v15.878h-15.878z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M515.959 66.634h16.105v16.332h-16.105zm-16.105-15.879h16.105v15.878h-16.105z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M483.977 50.982h16.105V66.86h-16.105z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M499.854 66.634h16.105v16.332h-16.105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.82 34.877h16.105v15.878H563.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M515.959 98.616h15.878v16.105h-15.878z"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -68,
    y: 323,
    width: 388,
    height: 286
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M148.052 431.133c0 29.145-19.27 52.772-43.041 52.772-23.77 0-172.288-102.224-172.288-131.369 0-29.145 213.391 10.979 237.162 10.979 23.771 0-21.833 38.472-21.833 67.618z",
    fill: "url(#paint6_linear_2012_6)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M164.769 556.023c0 29.145-19.27 52.772-43.041 52.772-23.77 0-156.195-6.794-156.195-35.939s9.789-98.183 33.56-98.183c23.77 0 165.676 52.205 165.676 81.35z",
    fill: "url(#paint7_radial_2012_6)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M213.595 431.212c64.138 57.928 34.51 28.817 89.599 27.351 8.642 1.664 23.313 1.743 12.86-11.258-13.065-16.252-8.854-27.731-25.183-45.437-16.329-17.706-26.273-35.696-50.924-63.857-24.652-28.162-26.548-4.948-54.34-7.148-27.792-2.201-15.116 1.294-53.461 42.155-38.345 40.861 17.311.266 81.449 58.194zm-60.553 91.118c-85.833 10.105-44.414 6.986-79.595 49.403-6.945 5.406-16.667 16.393 0 17.092 20.834.873 26.698 11.602 50.776 10.978 24.078-.623 44.164 3.743 81.591 3.743 37.427 0 21.208-16.717 41.169-36.179 19.962-19.462 8.983-12.226 3.494-67.993-5.49-55.766-11.603 12.85-97.435 22.956z",
    fill: "#D9D9D9"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#546FFF",
    strokeOpacity: 0.09,
    strokeWidth: 0.25,
    d: "M-8.391 491.64h299.167M-8.391 555.515h299.167M-8.391 427.765h299.167M-8.391 363.889h299.167M-8.391 587.453h299.167M-8.391 459.701h299.167M-8.391 523.576h299.167M-8.391 395.826h299.167M-8.391 331.951h299.167M-8.391 475.67h299.167M-8.391 539.546h299.167M-8.391 411.795h299.167M-8.391 347.92h299.167M-8.391 571.484h299.167M-8.391 443.733h299.167M-8.391 507.609h299.167M-8.391 379.858h299.167"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#546FFF",
    strokeOpacity: 0.09,
    strokeWidth: 1.261,
    d: "M80.584 509.963l-.001 1167.407M241.955 509.963V1677.37M161.271 509.963V1677.37"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    fill: "#546FFF"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.36,
    d: "M160.666 523.566h15.878v15.878h-15.878z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.25,
    d: "M80.82 523.566h15.878v15.878H80.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.11,
    d: "M224.631 411.965h15.878v15.651h-15.878z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.31,
    d: "M96.699 396.088h15.878v15.651H96.699z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.11,
    d: "M208.525 427.844h15.878v15.651h-15.878z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.31,
    d: "M80.594 411.965h15.878v15.651H80.594z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.11,
    d: "M208.525 411.965h15.878v15.651h-15.878z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.31,
    d: "M80.594 396.088h15.878v15.651H80.594z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.25,
    d: "M64.943 523.566h15.878v15.878H64.943z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.25,
    d: "M64.943 539.444h15.878v16.105H64.943zm-31.984-31.756h15.878v15.878H32.959z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.61,
    d: "M192.648 379.982h15.878v15.878h-15.878zm-15.877-18.147h15.878v15.878h-15.878zm-.175 17.92h15.878v16.105h-15.878z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M32.959 395.634h16.105v16.332H32.959zm-16.105-15.879h16.105v15.878H16.854z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M.977 379.982h16.105v15.878H.977z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M16.854 395.634h16.105v16.332H16.854z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.82 363.877h16.105v15.878H80.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.24,
    d: "M32.959 427.616h15.878v16.105H32.959z"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.26,
    d: "M224.631 507.688h15.878v15.878h-15.878zm15.877 15.878h15.878v15.878h-15.878z"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2012_6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2012_6)",
    stroke: "#546FFF",
    strokeLinecap: "round",
    strokeDasharray: "0.88 0.88"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M314.086 127.561c0 45.648-140.772 70.547-158.369 136.944-17.597 66.397-17.597 82.997 0 124.495",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M314.086 127.561c0 45.648-140.772 70.547-158.369 136.944-17.597 66.397-17.597 82.997 0 124.495",
    strokeWidth: 1.32
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M314.086 127.561c0 45.648-140.772 70.547-158.369 136.944-17.597 66.397-17.597 82.997 0 124.495",
    strokeWidth: 1.76
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M314.082 127.561V373",
    stroke: "#546FFF",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeDasharray: "0.88 0.88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M314.082 127.561V373",
    stroke: "#546FFF",
    strokeWidth: 1.32,
    strokeLinecap: "round",
    strokeDasharray: "0.88 0.88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M314.082 127.561l-.039 123.707-.031 98.966",
    stroke: "#546FFF",
    strokeWidth: 1.76,
    strokeLinecap: "round",
    strokeDasharray: "0.88 0.88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M473 273v277.146",
    stroke: "#546FFF",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeDasharray: "0.88 0.88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M473 273v277.146",
    stroke: "#546FFF",
    strokeWidth: 1.32,
    strokeLinecap: "round",
    strokeDasharray: "0.88 0.88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M473 273v277.146",
    stroke: "#546FFF",
    strokeWidth: 1.76,
    strokeLinecap: "round",
    strokeDasharray: "0.88 0.88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M153 273v277.146",
    stroke: "#546FFF",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeDasharray: "0.88 0.88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M153 273v277.146",
    stroke: "#546FFF",
    strokeWidth: 1.32,
    strokeLinecap: "round",
    strokeDasharray: "0.88 0.88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M153 273v277.146",
    stroke: "#546FFF",
    strokeWidth: 1.76,
    strokeLinecap: "round",
    strokeDasharray: "0.88 0.88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M314 273v277.146",
    stroke: "#546FFF",
    strokeWidth: 12,
    strokeLinecap: "round",
    strokeDasharray: "0.88 0.88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M314 273v277.146",
    stroke: "#546FFF",
    strokeWidth: 1.32,
    strokeLinecap: "round",
    strokeDasharray: "0.88 0.88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M314 273v277.146",
    stroke: "#546FFF",
    strokeWidth: 1.76,
    strokeLinecap: "round",
    strokeDasharray: "0.88 0.88"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2012_6)",
    stroke: "#546FFF",
    strokeLinecap: "round",
    strokeDasharray: "0.88 0.88"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.06,
    d: "M314.086 127.561c0 45.648 140.772 70.547 158.369 136.944 17.597 66.397 17.597 82.997 0 124.495",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M314.086 127.561c0 45.648 140.772 70.547 158.369 136.944 17.597 66.397 17.597 82.997 0 124.495",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M314.086 127.561c0 45.648 140.772 70.547 158.369 136.944 17.597 66.397 17.597 82.997 0 124.495",
    strokeWidth: 1.76
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M314.086 132.839a5.279 5.279 0 100-10.558 5.279 5.279 0 000 10.558z",
    fill: "#546FFF"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_2012_6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206 181c0-7.732 6.268-14 14-14h196c7.732 0 14 6.268 14 14v18c0 7.732-6.268 14-14 14H220c-7.732 0-14-6.268-14-14v-18z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M206 181c0-7.732 6.268-14 14-14h196c7.732 0 14 6.268 14 14v18c0 7.732-6.268 14-14 14H220c-7.732 0-14-6.268-14-14v-18z",
    fill: "#fff",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 167v1h196v-2H220v1zm210 14h-1v18h2v-18h-1zm-14 32v-1H220v2h196v-1zm-210-14h1v-18h-2v18h1zm14 14v-1c-7.18 0-13-5.82-13-13h-2c0 8.284 6.716 15 15 15v-1zm210-14h-1c0 7.18-5.82 13-13 13v2c8.284 0 15-6.716 15-15h-1zm-14-32v1c7.18 0 13 5.82 13 13h2c0-8.284-6.716-15-15-15v1zm-196 0v-1c-8.284 0-15 6.716-15 15h2c0-7.18 5.82-13 13-13v-1z",
    fill: "#546FFF",
    fillOpacity: 0.1,
    mask: "url(#e)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dig_2012_6)",
    clipPath: "url(#clip4_2012_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206 181c0-7.732 6.268-14 14-14h196c7.732 0 14 6.268 14 14v18c0 7.732-6.268 14-14 14H220c-7.732 0-14-6.268-14-14v-18z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dg_2012_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.5 190c0-7.179 5.82-13 13-13 7.179 0 13 5.821 13 13 0 7.18-5.821 13-13 13-7.18 0-13-5.82-13-13z",
    fill: "url(#paint8_linear_2012_6)",
    fillOpacity: 0.4,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_di_2012_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.264 190.001c0-6.758 5.478-12.236 12.235-12.236s12.235 5.478 12.235 12.236c0 6.757-5.478 12.235-12.235 12.235s-12.235-5.478-12.235-12.235z",
    fill: "url(#paint9_linear_2012_6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.499 177.825c6.725 0 12.176 5.451 12.176 12.176 0 6.724-5.451 12.175-12.176 12.175-6.725 0-12.176-5.451-12.176-12.175 0-6.725 5.451-12.176 12.176-12.176z",
    stroke: "#fff",
    strokeOpacity: 0.08,
    strokeWidth: 0.119
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.499 177.825c6.725 0 12.176 5.451 12.176 12.176 0 6.724-5.451 12.175-12.176 12.175-6.725 0-12.176-5.451-12.176-12.175 0-6.725 5.451-12.176 12.176-12.176z",
    stroke: "url(#paint10_linear_2012_6)",
    strokeWidth: 0.119
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.499 177.825c6.725 0 12.176 5.451 12.176 12.176 0 6.724-5.451 12.175-12.176 12.175-6.725 0-12.176-5.451-12.176-12.175 0-6.725 5.451-12.176 12.176-12.176z",
    stroke: "url(#paint11_linear_2012_6)",
    strokeWidth: 0.119
  })), /*#__PURE__*/React.createElement("path", {
    d: "M283.998 186.526a1.116 1.116 0 00-.517-.946 1.13 1.13 0 00-.528-.174 1.129 1.129 0 00-1.186.971 1.128 1.128 0 00.39 1.005l-.471 1.428a1.103 1.103 0 00-.392.097l-1.918-1.918a1.119 1.119 0 00-.676-1.531 1.112 1.112 0 00-.621-.019 1.11 1.11 0 00-.536.315 1.113 1.113 0 00-.233 1.172c.076.197.206.369.375.495l-.203.696a.39.39 0 00.131.415.391.391 0 00.621-.195l.204-.694c.132-.01.262-.044.383-.099l1.918 1.918a1.119 1.119 0 001.829 1.24 1.126 1.126 0 00-.131-1.667l.458-1.391a1.12 1.12 0 001.103-1.118zm-2.673 5.881l.244-.711a.414.414 0 00.02-.152.408.408 0 00-.132-.269.403.403 0 00-.284-.097.39.39 0 00-.346.265l-.249.729a1.11 1.11 0 00-.409.102l-1.909-1.885a1.119 1.119 0 00-.155-1.169 1.124 1.124 0 00-1.114-.383 1.118 1.118 0 00-.819 1.437c.064.198.182.375.341.509l-.466 1.388a1.113 1.113 0 00-1.041.988c-.031.261.032.524.176.743a1.114 1.114 0 001.374.417 1.12 1.12 0 00.241-1.921l.451-1.35c.159-.002.316-.037.46-.104l1.908 1.886a1.126 1.126 0 00.16 1.178 1.124 1.124 0 001.13.371 1.113 1.113 0 00.827-.855 1.118 1.118 0 00-.408-1.117z",
    opacity: 0.9,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_2012_6)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M271.596 188.756a8 8 0 006.657 9.147 8 8 0 10-6.657-9.147z",
    stroke: "#fff",
    strokeWidth: 0.259,
    strokeDasharray: "3 5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M312.707 188.111h-1.329a2.018 2.018 0 00-.797-1.3 2.228 2.228 0 00-.678-.341 2.635 2.635 0 00-.788-.115c-.503 0-.953.127-1.351.379-.395.253-.707.624-.937 1.113-.228.488-.341 1.085-.341 1.789 0 .711.113 1.31.341 1.799.23.488.544.858.941 1.108.398.25.846.375 1.343.375.275 0 .537-.037.784-.111.25-.077.476-.189.677-.337a2.043 2.043 0 00.806-1.282l1.329.004a3.54 3.54 0 01-.413 1.184 3.272 3.272 0 01-.78.929 3.513 3.513 0 01-1.082.601c-.406.142-.85.213-1.33.213-.755 0-1.429-.179-2.02-.537-.591-.36-1.056-.876-1.397-1.546-.338-.671-.507-1.471-.507-2.4 0-.931.17-1.731.511-2.399.341-.67.807-1.184 1.398-1.542.591-.361 1.262-.542 2.015-.542.463 0 .895.067 1.296.201.403.13.765.324 1.086.579.321.253.587.563.797.929.21.364.353.78.426 1.249zm2.748 2.003V194h-1.274v-8.727h1.257v3.247h.081c.153-.352.388-.632.703-.84.315-.207.727-.311 1.236-.311.449 0 .841.093 1.176.277.338.185.599.461.784.827.187.364.281.818.281 1.364V194h-1.274v-4.01c0-.48-.124-.852-.371-1.116-.247-.267-.591-.401-1.031-.401-.301 0-.571.064-.81.192a1.391 1.391 0 00-.558.562c-.133.245-.2.54-.2.887zm10.091 1.172v-3.831h1.278V194h-1.253v-1.134h-.068c-.15.35-.392.641-.724.874-.33.23-.74.345-1.232.345a2.21 2.21 0 01-1.116-.277 1.944 1.944 0 01-.759-.831c-.182-.366-.272-.819-.272-1.359v-4.163h1.274v4.009c0 .447.123.802.37 1.066.248.264.569.396.963.396.239 0 .476-.06.712-.179.239-.119.436-.3.592-.541.16-.242.238-.548.235-.92zm4.264-1.172V194h-1.274v-6.545h1.223v1.065h.081c.151-.347.387-.625.708-.835.323-.211.731-.316 1.223-.316.446 0 .836.094 1.171.282.336.184.596.46.78.826.185.367.277.82.277 1.36V194h-1.274v-4.01c0-.474-.123-.845-.371-1.112-.247-.27-.586-.405-1.018-.405-.296 0-.558.064-.788.192a1.38 1.38 0 00-.542.562c-.13.245-.196.54-.196.887zm7.07 1.666l-.009-1.556h.222l2.608-2.769h1.526l-2.975 3.153h-.2l-1.172 1.172zm-1.172 2.22v-8.727h1.274V194h-1.274zm4.134 0l-2.344-3.111.878-.89 3.03 4.001h-1.564zm2.546 0v-6.545h1.274V194h-1.274zm.643-7.555a.81.81 0 01-.571-.222.722.722 0 01-.234-.537c0-.21.078-.389.234-.537a.805.805 0 01.571-.226c.222 0 .411.076.567.226a.707.707 0 01.239.537c0 .207-.08.386-.239.537a.794.794 0 01-.567.222zm3.619 3.669V194h-1.274v-6.545h1.223v1.065h.081c.151-.347.386-.625.707-.835.324-.211.732-.316 1.223-.316.446 0 .837.094 1.172.282.336.184.595.46.78.826.185.367.277.82.277 1.36V194h-1.274v-4.01c0-.474-.124-.845-.371-1.112-.247-.27-.586-.405-1.018-.405-.296 0-.558.064-.789.192a1.384 1.384 0 00-.541.562c-.13.245-.196.54-.196.887zm8.642 6.477c-.52 0-.967-.068-1.342-.205a2.59 2.59 0 01-.912-.541 2.256 2.256 0 01-.528-.737l1.095-.452c.076.125.179.257.307.397.13.142.306.262.528.362.224.099.513.149.865.149.483 0 .882-.118 1.197-.354.316-.233.473-.605.473-1.116v-1.287h-.08a2.911 2.911 0 01-.333.464 1.789 1.789 0 01-.588.443c-.25.125-.575.188-.976.188-.517 0-.983-.121-1.398-.362-.411-.245-.738-.604-.98-1.078-.238-.478-.358-1.064-.358-1.76s.118-1.293.354-1.79c.239-.497.565-.878.98-1.142a2.55 2.55 0 011.411-.401c.406 0 .734.069.984.205.25.133.445.29.584.469.142.179.251.336.328.473h.094v-1.061h1.248v6.69c0 .562-.13 1.024-.392 1.385a2.3 2.3 0 01-1.061.801c-.443.173-.943.26-1.5.26zm-.013-3.746c.367 0 .677-.085.929-.256a1.59 1.59 0 00.58-.741c.134-.324.2-.712.2-1.163 0-.441-.065-.828-.196-1.164a1.726 1.726 0 00-.575-.784c-.253-.19-.565-.285-.938-.285-.383 0-.703.099-.958.298a1.8 1.8 0 00-.58.801 3.181 3.181 0 00-.192 1.134c0 .429.066.805.196 1.129.131.324.324.577.58.758.258.182.577.273.954.273zm5.515 1.236a.825.825 0 01-.601-.247.826.826 0 01-.252-.605c0-.233.084-.432.252-.597a.817.817 0 01.601-.251c.233 0 .433.083.601.251a.81.81 0 01.251.597c0 .156-.04.299-.119.43a.885.885 0 01-.307.307.81.81 0 01-.426.115zm3.398 0a.827.827 0 01-.601-.247.829.829 0 01-.251-.605.81.81 0 01.251-.597.819.819 0 01.601-.251c.233 0 .433.083.601.251a.805.805 0 01.251.597.808.808 0 01-.119.43.885.885 0 01-.307.307.81.81 0 01-.426.115zm3.399 0a.825.825 0 01-.601-.247.826.826 0 01-.252-.605c0-.233.084-.432.252-.597a.817.817 0 01.601-.251c.233 0 .433.083.6.251a.806.806 0 01.252.597c0 .156-.04.299-.119.43a.885.885 0 01-.307.307.81.81 0 01-.426.115z",
    fill: "#546FFF"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.248,
    filter: "url(#filter4_g_2012_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M285.754 479.747c0-26.37 21.377-47.747 47.747-47.747 26.369 0 47.746 21.377 47.746 47.747v18.506c0 26.37-21.377 47.747-47.746 47.747-26.37 0-47.747-21.377-47.747-47.747v-18.506z",
    fill: "#546FFF"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.248,
    filter: "url(#filter5_g_2012_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.129 512.37c0-21.743 17.627-39.37 39.37-39.37 21.744 0 39.37 17.627 39.37 39.37v15.26c0 21.743-17.626 39.37-39.37 39.37-21.743 0-39.37-17.627-39.37-39.37v-15.26z",
    fill: "#546FFF"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.248,
    filter: "url(#filter6_g_2012_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462.941 514.558c0-24.056 19.502-43.558 43.559-43.558s43.558 19.502 43.558 43.558v16.884c0 24.056-19.501 43.558-43.558 43.558s-43.559-19.502-43.559-43.558v-16.884z",
    fill: "#546FFF"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_dd_2012_6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.338 268.473a4.601 4.601 0 014.601-4.601h107.366a4.601 4.601 0 014.602 4.601v116.441a4.601 4.601 0 01-4.602 4.601H103.939a4.601 4.601 0 01-4.601-4.601V268.473z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99.338 268.473a4.601 4.601 0 014.601-4.601h107.366a4.601 4.601 0 014.602 4.601v116.441a4.601 4.601 0 01-4.602 4.601H103.939a4.601 4.601 0 01-4.601-4.601V268.473z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.338 268.473a4.601 4.601 0 014.601-4.601h107.366a4.601 4.601 0 014.602 4.601v116.441a4.601 4.601 0 01-4.602 4.601H103.939a4.601 4.601 0 01-4.601-4.601V268.473z",
    fill: "url(#paint12_linear_2012_6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.939 263.872v.767h107.366v-1.534H103.939v.767zm111.968 4.601h-.767v116.441h1.534V268.473h-.767zm-4.602 121.042v-.767H103.939v1.534h107.366v-.767zm-111.967-4.601h.767V268.473h-1.534v116.441h.767zm4.601 4.601v-.767a3.834 3.834 0 01-3.834-3.834h-1.534a5.368 5.368 0 005.368 5.368v-.767zm111.968-4.601h-.767a3.834 3.834 0 01-3.835 3.834v1.534a5.368 5.368 0 005.369-5.368h-.767zm-4.602-121.042v.767a3.834 3.834 0 013.835 3.834h1.534a5.368 5.368 0 00-5.369-5.368v.767zm-107.366 0v-.767a5.368 5.368 0 00-5.368 5.368h1.534a3.834 3.834 0 013.834-3.834v-.767z",
    fill: "#E4E7EE",
    mask: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.774 273.841c0-.847.687-1.533 1.534-1.533h51.766a1.534 1.534 0 110 3.067h-51.766a1.534 1.534 0 01-1.534-1.534z",
    fill: "#A8AFC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.774 282.661c0-.635.515-1.151 1.151-1.151h32.593a1.15 1.15 0 010 2.301h-32.593a1.15 1.15 0 01-1.151-1.15z",
    fill: "#C8CDD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.774 293.781c0-.424.344-.767.767-.767h24.667c.423 0 .767.343.767.767v1.917a.767.767 0 01-.767.767h-24.667a.767.767 0 01-.767-.767v-1.917zm27.734 0c0-.424.344-.767.767-.767h15.308c.424 0 .767.343.767.767v1.917a.766.766 0 01-.767.767h-15.308a.767.767 0 01-.767-.767v-1.917zm18.376 0c0-.424.343-.767.767-.767h15.308c.424 0 .767.343.767.767v1.917a.766.766 0 01-.767.767h-15.308a.766.766 0 01-.767-.767v-1.917zm18.376 0c0-.424.343-.767.767-.767h15.308c.423 0 .767.343.767.767v1.917a.767.767 0 01-.767.767h-15.308a.766.766 0 01-.767-.767v-1.917zm18.375 0c0-.424.344-.767.767-.767h15.308c.424 0 .767.343.767.767v1.917a.766.766 0 01-.767.767h-15.308a.767.767 0 01-.767-.767v-1.917z",
    fill: "#B8BFCE",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.774 299.533c0-.424.344-.767.767-.767h24.667c.423 0 .767.343.767.767v1.15a.767.767 0 01-.767.767h-24.667a.767.767 0 01-.767-.767v-1.15zm27.734 0c0-.424.344-.767.767-.767h15.308c.424 0 .767.343.767.767v1.15a.766.766 0 01-.767.767h-15.308a.767.767 0 01-.767-.767v-1.15zm18.376 0c0-.424.343-.767.767-.767h15.308c.424 0 .767.343.767.767v1.15a.766.766 0 01-.767.767h-15.308a.766.766 0 01-.767-.767v-1.15zm18.376 0c0-.424.343-.767.767-.767h15.308c.423 0 .767.343.767.767v1.15a.767.767 0 01-.767.767h-15.308a.766.766 0 01-.767-.767v-1.15zm18.375 0c0-.424.344-.767.767-.767h15.308c.424 0 .767.343.767.767v1.15a.766.766 0 01-.767.767h-15.308a.767.767 0 01-.767-.767v-1.15z",
    fill: "#D5D9E3",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.774 303.751c0-.424.344-.767.767-.767h24.667c.423 0 .767.343.767.767v1.15a.768.768 0 01-.767.767h-24.667a.768.768 0 01-.767-.767v-1.15zm27.734 0c0-.424.344-.767.767-.767h15.308c.424 0 .767.343.767.767v1.15a.767.767 0 01-.767.767h-15.308a.768.768 0 01-.767-.767v-1.15zm18.376 0c0-.424.343-.767.767-.767h15.308c.424 0 .767.343.767.767v1.15a.767.767 0 01-.767.767h-15.308a.767.767 0 01-.767-.767v-1.15zm18.376 0c0-.424.343-.767.767-.767h15.308c.423 0 .767.343.767.767v1.15a.768.768 0 01-.767.767h-15.308a.767.767 0 01-.767-.767v-1.15zm18.375 0c0-.424.344-.767.767-.767h15.308c.424 0 .767.343.767.767v1.15a.767.767 0 01-.767.767h-15.308a.768.768 0 01-.767-.767v-1.15z",
    fill: "#E2E5EC",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.774 307.968c0-.423.344-.766.767-.766h24.667c.423 0 .767.343.767.766v1.151a.768.768 0 01-.767.767h-24.667a.768.768 0 01-.767-.767v-1.151zm27.734 0c0-.423.344-.766.767-.766h15.308c.424 0 .767.343.767.766v1.151a.767.767 0 01-.767.767h-15.308a.768.768 0 01-.767-.767v-1.151zm18.376 0c0-.423.343-.766.767-.766h15.308c.424 0 .767.343.767.766v1.151a.767.767 0 01-.767.767h-15.308a.767.767 0 01-.767-.767v-1.151zm18.376 0c0-.423.343-.766.767-.766h15.308c.423 0 .767.343.767.766v1.151a.768.768 0 01-.767.767h-15.308a.767.767 0 01-.767-.767v-1.151zm18.375 0c0-.423.344-.766.767-.766h15.308c.424 0 .767.343.767.766v1.151a.767.767 0 01-.767.767h-15.308a.768.768 0 01-.767-.767v-1.151z",
    fill: "#D5D9E3",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.774 312.186c0-.423.344-.766.767-.766h24.667c.423 0 .767.343.767.766v1.151a.768.768 0 01-.767.767h-24.667a.768.768 0 01-.767-.767v-1.151zm27.734 0c0-.423.344-.766.767-.766h15.308c.424 0 .767.343.767.766v1.151a.767.767 0 01-.767.767h-15.308a.768.768 0 01-.767-.767v-1.151zm18.376 0c0-.423.343-.766.767-.766h15.308c.424 0 .767.343.767.766v1.151a.767.767 0 01-.767.767h-15.308a.767.767 0 01-.767-.767v-1.151zm18.376 0c0-.423.343-.766.767-.766h15.308c.423 0 .767.343.767.766v1.151a.768.768 0 01-.767.767h-15.308a.767.767 0 01-.767-.767v-1.151zm18.375 0c0-.423.344-.766.767-.766h15.308c.424 0 .767.343.767.766v1.151a.767.767 0 01-.767.767h-15.308a.768.768 0 01-.767-.767v-1.151z",
    fill: "#E2E5EC",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.774 316.404c0-.423.344-.767.767-.767h24.667c.423 0 .767.344.767.767v1.151a.768.768 0 01-.767.767h-24.667a.768.768 0 01-.767-.767v-1.151zm27.734 0c0-.423.344-.767.767-.767h15.308c.424 0 .767.344.767.767v1.151a.767.767 0 01-.767.767h-15.308a.768.768 0 01-.767-.767v-1.151zm18.376 0c0-.423.343-.767.767-.767h15.308c.424 0 .767.344.767.767v1.151a.767.767 0 01-.767.767h-15.308a.767.767 0 01-.767-.767v-1.151zm18.376 0c0-.423.343-.767.767-.767h15.308c.423 0 .767.344.767.767v1.151a.768.768 0 01-.767.767h-15.308a.767.767 0 01-.767-.767v-1.151zm18.375 0c0-.423.344-.767.767-.767h15.308c.424 0 .767.344.767.767v1.151a.767.767 0 01-.767.767h-15.308a.768.768 0 01-.767-.767v-1.151z",
    fill: "#D5D9E3",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.774 320.622c0-.423.344-.767.767-.767h24.667c.423 0 .767.344.767.767v1.151a.768.768 0 01-.767.767h-24.667a.768.768 0 01-.767-.767v-1.151zm27.734 0c0-.423.344-.767.767-.767h15.308c.424 0 .767.344.767.767v1.151a.767.767 0 01-.767.767h-15.308a.768.768 0 01-.767-.767v-1.151zm18.376 0c0-.423.343-.767.767-.767h15.308c.424 0 .767.344.767.767v1.151a.767.767 0 01-.767.767h-15.308a.767.767 0 01-.767-.767v-1.151zm18.376 0c0-.423.343-.767.767-.767h15.308c.423 0 .767.344.767.767v1.151a.768.768 0 01-.767.767h-15.308a.767.767 0 01-.767-.767v-1.151zm18.375 0c0-.423.344-.767.767-.767h15.308c.424 0 .767.344.767.767v1.151a.767.767 0 01-.767.767h-15.308a.768.768 0 01-.767-.767v-1.151z",
    fill: "#E2E5EC",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.774 324.84c0-.423.344-.767.767-.767h24.667c.423 0 .767.344.767.767v1.151a.768.768 0 01-.767.767h-24.667a.768.768 0 01-.767-.767v-1.151zm27.734 0c0-.423.344-.767.767-.767h15.308c.424 0 .767.344.767.767v1.151a.767.767 0 01-.767.767h-15.308a.768.768 0 01-.767-.767v-1.151zm18.376 0c0-.423.343-.767.767-.767h15.308c.424 0 .767.344.767.767v1.151a.767.767 0 01-.767.767h-15.308a.767.767 0 01-.767-.767v-1.151zm18.376 0c0-.423.343-.767.767-.767h15.308c.423 0 .767.344.767.767v1.151a.768.768 0 01-.767.767h-15.308a.767.767 0 01-.767-.767v-1.151zm18.375 0c0-.423.344-.767.767-.767h15.308c.424 0 .767.344.767.767v1.151a.767.767 0 01-.767.767h-15.308a.768.768 0 01-.767-.767v-1.151z",
    fill: "#D5D9E3",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.774 329.058c0-.423.344-.767.767-.767h24.667c.423 0 .767.344.767.767v1.151a.768.768 0 01-.767.767h-24.667a.768.768 0 01-.767-.767v-1.151zm27.734 0c0-.423.344-.767.767-.767h15.308c.424 0 .767.344.767.767v1.151a.767.767 0 01-.767.767h-15.308a.768.768 0 01-.767-.767v-1.151zm18.376 0c0-.423.343-.767.767-.767h15.308c.424 0 .767.344.767.767v1.151a.767.767 0 01-.767.767h-15.308a.767.767 0 01-.767-.767v-1.151zm18.376 0c0-.423.343-.767.767-.767h15.308c.423 0 .767.344.767.767v1.151a.768.768 0 01-.767.767h-15.308a.767.767 0 01-.767-.767v-1.151zm18.375 0c0-.423.344-.767.767-.767h15.308c.424 0 .767.344.767.767v1.151a.767.767 0 01-.767.767h-15.308a.768.768 0 01-.767-.767v-1.151z",
    fill: "#E2E5EC",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.774 333.276c0-.423.344-.767.767-.767h24.667c.423 0 .767.344.767.767v1.151a.767.767 0 01-.767.766h-24.667a.767.767 0 01-.767-.766v-1.151zm27.734 0c0-.423.344-.767.767-.767h15.308c.424 0 .767.344.767.767v1.151a.766.766 0 01-.767.766h-15.308a.767.767 0 01-.767-.766v-1.151zm18.376 0c0-.423.343-.767.767-.767h15.308c.424 0 .767.344.767.767v1.151a.766.766 0 01-.767.766h-15.308a.766.766 0 01-.767-.766v-1.151zm18.376 0c0-.423.343-.767.767-.767h15.308c.423 0 .767.344.767.767v1.151a.767.767 0 01-.767.766h-15.308a.766.766 0 01-.767-.766v-1.151zm18.375 0c0-.423.344-.767.767-.767h15.308c.424 0 .767.344.767.767v1.151a.766.766 0 01-.767.766h-15.308a.767.767 0 01-.767-.766v-1.151z",
    fill: "#D5D9E3",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.774 337.494c0-.423.344-.767.767-.767h24.667c.423 0 .767.344.767.767v1.151a.767.767 0 01-.767.766h-24.667a.767.767 0 01-.767-.766v-1.151zm27.734 0c0-.423.344-.767.767-.767h15.308c.424 0 .767.344.767.767v1.151a.766.766 0 01-.767.766h-15.308a.767.767 0 01-.767-.766v-1.151zm18.376 0c0-.423.343-.767.767-.767h15.308c.424 0 .767.344.767.767v1.151a.766.766 0 01-.767.766h-15.308a.766.766 0 01-.767-.766v-1.151zm18.376 0c0-.423.343-.767.767-.767h15.308c.423 0 .767.344.767.767v1.151a.767.767 0 01-.767.766h-15.308a.766.766 0 01-.767-.766v-1.151zm18.375 0c0-.423.344-.767.767-.767h15.308c.424 0 .767.344.767.767v1.151a.766.766 0 01-.767.766h-15.308a.767.767 0 01-.767-.766v-1.151z",
    fill: "#E2E5EC",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.774 341.712c0-.423.344-.767.767-.767h24.667c.423 0 .767.344.767.767v1.15a.767.767 0 01-.767.767h-24.667a.767.767 0 01-.767-.767v-1.15zm27.734 0c0-.423.344-.767.767-.767h15.308c.424 0 .767.344.767.767v1.15a.766.766 0 01-.767.767h-15.308a.767.767 0 01-.767-.767v-1.15zm18.376 0c0-.423.343-.767.767-.767h15.308c.424 0 .767.344.767.767v1.15a.766.766 0 01-.767.767h-15.308a.766.766 0 01-.767-.767v-1.15zm18.376 0c0-.423.343-.767.767-.767h15.308c.423 0 .767.344.767.767v1.15a.767.767 0 01-.767.767h-15.308a.766.766 0 01-.767-.767v-1.15zm18.375 0c0-.423.344-.767.767-.767h15.308c.424 0 .767.344.767.767v1.15a.766.766 0 01-.767.767h-15.308a.767.767 0 01-.767-.767v-1.15z",
    fill: "#D5D9E3",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.774 345.93c0-.424.344-.767.767-.767h24.667c.423 0 .767.343.767.767v1.15a.767.767 0 01-.767.767h-24.667a.767.767 0 01-.767-.767v-1.15zm27.734 0c0-.424.344-.767.767-.767h15.308c.424 0 .767.343.767.767v1.15a.766.766 0 01-.767.767h-15.308a.767.767 0 01-.767-.767v-1.15zm18.376 0c0-.424.343-.767.767-.767h15.308c.424 0 .767.343.767.767v1.15a.766.766 0 01-.767.767h-15.308a.766.766 0 01-.767-.767v-1.15zm18.376 0c0-.424.343-.767.767-.767h15.308c.423 0 .767.343.767.767v1.15a.767.767 0 01-.767.767h-15.308a.766.766 0 01-.767-.767v-1.15zm18.375 0c0-.424.344-.767.767-.767h15.308c.424 0 .767.343.767.767v1.15a.766.766 0 01-.767.767h-15.308a.767.767 0 01-.767-.767v-1.15z",
    fill: "#E2E5EC",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.774 350.915h99.697v6.519h-99.697v-6.519z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M107.774 350.915v.767h99.697v-1.534h-99.697v.767z",
    fill: "#E8EAF0",
    mask: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.774 355.516c0-.423.344-.767.767-.767h24.667c.423 0 .767.344.767.767v1.151a.768.768 0 01-.767.767h-24.667a.768.768 0 01-.767-.767v-1.151zm27.734 0c0-.423.344-.767.767-.767h15.308c.424 0 .767.344.767.767v1.151a.767.767 0 01-.767.767h-15.308a.768.768 0 01-.767-.767v-1.151zm18.376 0c0-.423.343-.767.767-.767h15.308c.424 0 .767.344.767.767v1.151a.767.767 0 01-.767.767h-15.308a.767.767 0 01-.767-.767v-1.151zm18.376 0c0-.423.343-.767.767-.767h15.308c.423 0 .767.344.767.767v1.151a.768.768 0 01-.767.767h-15.308a.767.767 0 01-.767-.767v-1.151zm18.375 0c0-.423.344-.767.767-.767h15.308c.424 0 .767.344.767.767v1.151a.767.767 0 01-.767.767h-15.308a.768.768 0 01-.767-.767v-1.151z",
    fill: "#C4CAD6",
    opacity: 0.55
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M105.192 400.184c0 2.027-.701 3.04-2.105 3.04-.881 0-1.474-.329-1.778-.988h-.027c.015.029.022.326.022.892v2.272h-.972v-6.891c0-.609-.011-1.01-.033-1.203h.94a8.854 8.854 0 01.038.564c.011.175.016.306.016.392h.021c.179-.376.407-.649.683-.817.279-.172.642-.258 1.09-.258.709 0 1.237.246 1.584.736.348.487.521 1.241.521 2.261zm-.999 0c0-.809-.109-1.385-.327-1.729-.219-.347-.562-.521-1.032-.521-.54 0-.931.197-1.17.591-.24.39-.36.983-.36 1.778 0 .762.12 1.321.36 1.675.239.355.626.532 1.16.532.476 0 .823-.181 1.042-.542.218-.362.327-.956.327-1.784zm5.265 5.21c-.601 0-1.085-.123-1.45-.37s-.598-.602-.698-1.064l.988-.134c.061.269.192.474.392.618.204.147.471.22.801.22.888 0 1.332-.564 1.332-1.692v-1.042h-.011a1.91 1.91 0 01-.73.838c-.312.19-.683.285-1.112.285-.709 0-1.229-.231-1.558-.693-.326-.466-.489-1.196-.489-2.192 0-1.013.176-1.758.527-2.234.351-.48.891-.72 1.622-.72.404 0 .755.095 1.052.285.301.186.532.453.693.8h.016c0-.107.008-.288.022-.542.014-.258.029-.408.043-.451h.918c-.021.193-.032.594-.032 1.203v4.436c0 .813-.19 1.424-.569 1.832-.38.412-.965.617-1.757.617zm1.365-5.236c0-.691-.135-1.234-.403-1.628-.269-.397-.637-.596-1.107-.596-.49 0-.845.172-1.063.516-.218.34-.328.909-.328 1.708 0 .54.045.968.135 1.283.093.312.236.539.429.682.194.144.464.215.811.215.305 0 .571-.084.801-.252.232-.172.411-.421.537-.747.125-.329.188-.723.188-1.181zm4.814 2.959v-1.606h1.262v1.606h-1.262zm11.814 0v-.779h2.357v-5.484c-.132.28-.447.523-.945.731a3.744 3.744 0 01-1.461.311v-.795c.53 0 1.03-.116 1.499-.349.472-.232.802-.526.988-.881h.892v6.467h1.896v.779h-5.226zm6.887-2.422v-.736h4.769v.736h-4.769zm11.807.435c0 .666-.226 1.181-.677 1.547-.451.365-1.081.547-1.891.547-.766 0-1.378-.173-1.837-.521-.458-.347-.728-.857-.811-1.53l.999-.092c.129.896.679 1.343 1.649 1.343.487 0 .869-.113 1.144-.338.28-.226.419-.555.419-.988a.97.97 0 00-.247-.677 1.503 1.503 0 00-.66-.425 2.78 2.78 0 00-.94-.15h-.548v-.838h.526c.308 0 .589-.05.844-.15.257-.104.46-.249.606-.435.147-.186.221-.407.221-.661 0-.379-.12-.675-.36-.886-.237-.215-.589-.322-1.058-.322-.426 0-.772.109-1.037.327-.261.219-.414.527-.456.924l-.973-.075c.072-.62.328-1.103.768-1.45.444-.348 1.014-.521 1.708-.521.76 0 1.349.168 1.768.505.422.333.633.798.633 1.396 0 .426-.141.797-.424 1.112-.283.315-.67.523-1.16.623v.021c.541.061.974.251 1.3.57.329.318.494.7.494 1.144z",
    fill: "#9B6B2F"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_dd_2012_6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.907 268.345a4.601 4.601 0 014.601-4.601h107.366a4.602 4.602 0 014.602 4.601v116.569a4.602 4.602 0 01-4.602 4.601H264.508a4.601 4.601 0 01-4.601-4.601V268.345z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M259.907 268.345a4.601 4.601 0 014.601-4.601h107.366a4.602 4.602 0 014.602 4.601v116.569a4.602 4.602 0 01-4.602 4.601H264.508a4.601 4.601 0 01-4.601-4.601V268.345z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.907 268.345a4.601 4.601 0 014.601-4.601h107.366a4.602 4.602 0 014.602 4.601v116.569a4.602 4.602 0 01-4.602 4.601H264.508a4.601 4.601 0 01-4.601-4.601V268.345z",
    fill: "url(#paint13_linear_2012_6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.508 263.744v.766h107.366v-1.533H264.508v.767zm111.968 4.601h-.767v116.569h1.533V268.345h-.766zm-4.602 121.17v-.767H264.508v1.534h107.366v-.767zm-111.967-4.601h.767V268.345h-1.534v116.569h.767zm4.601 4.601v-.767a3.834 3.834 0 01-3.834-3.834h-1.534a5.368 5.368 0 005.368 5.368v-.767zm111.968-4.601h-.767a3.835 3.835 0 01-3.835 3.834v1.534a5.368 5.368 0 005.368-5.368h-.766zm-4.602-121.17v.766a3.835 3.835 0 013.835 3.835h1.533a5.368 5.368 0 00-5.368-5.368v.767zm-107.366 0v-.767a5.368 5.368 0 00-5.368 5.368h1.534a3.834 3.834 0 013.834-3.835v-.766z",
    fill: "#E4E7EE",
    mask: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.344 273.33c0-.847.686-1.534 1.534-1.534h51.765a1.534 1.534 0 010 3.068h-51.765a1.534 1.534 0 01-1.534-1.534z",
    fill: "#A8AFC0"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.344 284.067a3.067 3.067 0 013.067-3.068h93.562a3.068 3.068 0 013.068 3.068v39.878a3.068 3.068 0 01-3.068 3.068h-93.562a3.067 3.067 0 01-3.067-3.068v-39.878z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M268.344 284.067a3.067 3.067 0 013.067-3.068h93.562a3.068 3.068 0 013.068 3.068v39.878a3.068 3.068 0 01-3.068 3.068h-93.562a3.067 3.067 0 01-3.067-3.068v-39.878z",
    fill: "#ECEEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.411 280.999v.767h93.562v-1.534h-93.562v.767zm96.63 3.068h-.767v39.878h1.534v-39.878h-.767zm-3.068 42.946v-.767h-93.562v1.534h93.562v-.767zm-96.629-3.068h.767v-39.878h-1.534v39.878h.767zm3.067 3.068v-.767a2.3 2.3 0 01-2.3-2.301h-1.534a3.835 3.835 0 003.834 3.835v-.767zm96.63-3.068h-.767a2.3 2.3 0 01-2.301 2.301v1.534a3.835 3.835 0 003.835-3.835h-.767zm-3.068-42.946v.767a2.3 2.3 0 012.301 2.301h1.534a3.835 3.835 0 00-3.835-3.835v.767zm-93.562 0v-.767a3.835 3.835 0 00-3.834 3.835h1.534a2.3 2.3 0 012.3-2.301v-.767z",
    fill: "#E0E3EA",
    mask: "url(#i)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_2012_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.477 296.721h-14.571c-.847 0-1.533.687-1.533 1.534v11.503c0 .847.686 1.534 1.533 1.534h14.571c.848 0 1.534-.687 1.534-1.534v-11.503c0-.847-.686-1.534-1.534-1.534z",
    stroke: "#BCC2CF",
    strokeWidth: 0.614
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.124 303.623a1.918 1.918 0 10.001-3.835 1.918 1.918 0 00-.001 3.835z",
    fill: "#DDE0E8",
    stroke: "#BCC2CF",
    strokeWidth: 0.537
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.756 308.608l4.602-4.602 3.067 3.068 3.835-4.601 5.368 6.135",
    fill: "#E8EAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.756 308.608l4.602-4.602 3.067 3.068 3.835-4.601 5.368 6.135",
    stroke: "#BCC2CF",
    strokeWidth: 0.614
  })), /*#__PURE__*/React.createElement("path", {
    d: "M268.345 335.832c0-.635.515-1.15 1.15-1.15h85.432a1.15 1.15 0 010 2.3h-85.432a1.15 1.15 0 01-1.15-1.15zm0 4.985c0-.635.515-1.15 1.15-1.15h69.476a1.15 1.15 0 110 2.3h-69.476a1.15 1.15 0 01-1.15-1.15zm0 4.985a1.15 1.15 0 011.15-1.151h92.411a1.15 1.15 0 110 2.301h-92.411a1.15 1.15 0 01-1.15-1.15zm0 4.985a1.15 1.15 0 011.15-1.151h57.518a1.15 1.15 0 010 2.301h-57.518a1.15 1.15 0 01-1.15-1.15zm0 4.984c0-.635.515-1.15 1.15-1.15h79.446a1.15 1.15 0 010 2.301h-79.446a1.15 1.15 0 01-1.15-1.151zm0 4.985c0-.635.515-1.15 1.15-1.15h75.462a1.15 1.15 0 010 2.301h-75.462a1.15 1.15 0 01-1.15-1.151zm0 4.985c0-.635.515-1.15 1.15-1.15h87.427a1.15 1.15 0 010 2.3h-87.427a1.15 1.15 0 01-1.15-1.15zm0 4.985c0-.635.515-1.15 1.15-1.15h52.533a1.15 1.15 0 010 2.3h-52.533a1.15 1.15 0 01-1.15-1.15zm0 4.985a1.15 1.15 0 011.15-1.151h82.442a1.15 1.15 0 010 2.301h-82.442a1.15 1.15 0 01-1.15-1.15zm0 4.985a1.15 1.15 0 011.15-1.151h65.492a1.15 1.15 0 010 2.301h-65.492a1.15 1.15 0 01-1.15-1.15z",
    fill: "#D5D9E3",
    opacity: 0.55
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M265.762 399.8c0 2.027-.702 3.04-2.106 3.04-.881 0-1.473-.329-1.778-.988h-.026c.014.029.021.326.021.892v2.272h-.972v-6.892c0-.608-.011-1.009-.032-1.203h.94c.003.015.009.068.016.161.007.09.014.224.021.403.011.176.016.306.016.392h.022c.179-.376.406-.648.682-.816.279-.172.643-.258 1.09-.258.709 0 1.237.245 1.585.736.347.487.521 1.241.521 2.261zm-.999 0c0-.809-.11-1.386-.328-1.729-.218-.348-.562-.521-1.031-.521-.541 0-.931.197-1.171.591-.24.39-.36.982-.36 1.777 0 .763.12 1.322.36 1.676.24.355.627.532 1.16.532.476 0 .824-.181 1.042-.543.218-.361.328-.956.328-1.783zm5.265 5.21c-.602 0-1.085-.123-1.45-.37-.366-.248-.598-.602-.699-1.064l.989-.134a.996.996 0 00.392.617c.204.147.471.221.8.221.888 0 1.332-.564 1.332-1.692v-1.042h-.011a1.91 1.91 0 01-.73.838c-.312.189-.682.284-1.112.284-.709 0-1.228-.231-1.558-.693-.325-.465-.488-1.195-.488-2.191 0-1.013.175-1.758.526-2.234.351-.48.892-.72 1.622-.72.405 0 .756.095 1.053.285.301.186.532.453.693.8h.016c0-.108.007-.288.021-.543.015-.257.029-.408.043-.451h.919c-.022.194-.033.595-.033 1.203v4.437c0 .813-.189 1.423-.569 1.831-.379.412-.965.618-1.756.618zm1.364-5.237c0-.691-.134-1.233-.403-1.627-.268-.398-.637-.596-1.106-.596-.491 0-.845.172-1.064.515-.218.34-.327.91-.327 1.708 0 .541.044.969.134 1.284.093.312.236.539.43.682.193.143.463.215.811.215.304 0 .571-.084.8-.252.233-.172.412-.421.537-.747.125-.329.188-.723.188-1.182zm4.814 2.96v-1.606h1.262v1.606h-1.262zm16.003-1.714v1.714h-.966v-1.714h-3.513v-.752l3.41-4.78h1.069v4.77h1.01v.762h-1.01zm-.966-4.484l-2.686 3.722h2.686v-3.722zm3.664 3.775v-.735h4.77v.735h-4.77zm11.807.038c0 .498-.106.935-.317 1.311a2.157 2.157 0 01-.929.875c-.405.204-.884.306-1.439.306-.706 0-1.275-.154-1.708-.462-.434-.308-.708-.753-.822-1.337l.977-.113c.204.748.729 1.123 1.574 1.123.505 0 .908-.151 1.209-.452.3-.3.451-.71.451-1.229 0-.445-.149-.808-.446-1.091-.297-.283-.695-.424-1.192-.424-.262 0-.505.041-.731.123a2.191 2.191 0 00-.677.419h-.945l.252-3.91h4.303v.779h-3.411l-.156 2.283c.419-.323.94-.484 1.563-.484.731 0 1.32.212 1.767.634.452.419.677.969.677 1.649z",
    fill: "#9B6B2F"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_dd_2012_6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.476 268.345a4.601 4.601 0 014.601-4.601h107.366a4.601 4.601 0 014.601 4.601v116.569a4.601 4.601 0 01-4.601 4.601H425.077a4.601 4.601 0 01-4.601-4.601V268.345z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M420.476 268.345a4.601 4.601 0 014.601-4.601h107.366a4.601 4.601 0 014.601 4.601v116.569a4.601 4.601 0 01-4.601 4.601H425.077a4.601 4.601 0 01-4.601-4.601V268.345z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.476 268.345a4.601 4.601 0 014.601-4.601h107.366a4.601 4.601 0 014.601 4.601v116.569a4.601 4.601 0 01-4.601 4.601H425.077a4.601 4.601 0 01-4.601-4.601V268.345z",
    fill: "url(#paint14_linear_2012_6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.077 263.744v.766h107.366v-1.533H425.077v.767zm111.967 4.601h-.767v116.569h1.534V268.345h-.767zm-4.601 121.17v-.767H425.077v1.534h107.366v-.767zm-111.967-4.601h.766V268.345h-1.533v116.569h.767zm4.601 4.601v-.767a3.835 3.835 0 01-3.835-3.834h-1.533a5.368 5.368 0 005.368 5.368v-.767zm111.967-4.601h-.767a3.834 3.834 0 01-3.834 3.834v1.534a5.368 5.368 0 005.368-5.368h-.767zm-4.601-121.17v.766a3.834 3.834 0 013.834 3.835h1.534a5.368 5.368 0 00-5.368-5.368v.767zm-107.366 0v-.767a5.368 5.368 0 00-5.368 5.368h1.533a3.835 3.835 0 013.835-3.835v-.766z",
    fill: "#E4E7EE",
    mask: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.911 273.713c0-.847.687-1.534 1.534-1.534h56.751a1.533 1.533 0 010 3.068h-56.751a1.534 1.534 0 01-1.534-1.534z",
    fill: "#A8AFC0"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "k",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M515.233 288.668a.767.767 0 11.767 1.328l-5.313 3.068a.768.768 0 01-.767-1.329l5.313-3.067z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M515.233 288.668a.767.767 0 11.767 1.328l-5.313 3.068a.768.768 0 01-.767-1.329l5.313-3.067z",
    fill: "#ECEEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516 289.996l-.383-.664-5.313 3.068.383.664.383.664 5.314-3.068-.384-.664zm-6.08 1.739l.384.665 5.313-3.068-.384-.664-.383-.664-5.313 3.067.383.664zm-.281 1.048l.665-.383-.384-.665-.383-.664a1.534 1.534 0 00-.562 2.095l.664-.383zm1.048.281l-.383-.664-.665.383-.664.383a1.534 1.534 0 002.095.562l-.383-.664zm5.594-4.116l-.664.384.383.664.384.664a1.533 1.533 0 00.561-2.095l-.664.383zm0 0l.664-.383a1.533 1.533 0 00-2.095-.561l.383.664.384.664.664-.384z",
    fill: "#C8CDD8",
    mask: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.79 290.386h.001l-1.661.959 1.66-.959z",
    fill: "#C4CAD6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCD0DA",
    d: "M509.448 292.451l.384.664-3.32 1.917-.384-.664z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.279 295.57a.767.767 0 01.767 1.328l-5.314 3.068a.768.768 0 01-.767-1.329l5.314-3.067z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M503.279 295.57a.767.767 0 01.767 1.328l-5.314 3.068a.768.768 0 01-.767-1.329l5.314-3.067z",
    fill: "#ECEEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.046 296.898l-.384-.664-5.313 3.068.383.664.384.664 5.313-3.068-.383-.664zm-6.081 1.739l.384.665 5.313-3.068-.383-.664-.384-.664-5.313 3.067.383.664zm-.28 1.048l.664-.383-.384-.665-.383-.664a1.534 1.534 0 00-.561 2.096l.664-.384zm1.047.281l-.383-.664-.664.383-.664.384a1.534 1.534 0 002.095.561l-.384-.664zm5.594-4.115l-.664.383.384.664.383.664a1.532 1.532 0 00.561-2.095l-.664.384zm0 0l.664-.384a1.533 1.533 0 00-2.095-.561l.384.664.383.664.664-.383z",
    fill: "#C8CDD8",
    mask: "url(#l)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.836 297.288v.001l-1.66.958 1.66-.959z",
    fill: "#C4CAD6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCD0DA",
    d: "M497.493 299.353l.384.664-3.32 1.917-.384-.664z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "m",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M491.324 302.472a.767.767 0 01.767 1.328l-5.314 3.068a.766.766 0 01-.767-1.328l5.314-3.068z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M491.324 302.472a.767.767 0 01.767 1.328l-5.314 3.068a.766.766 0 01-.767-1.328l5.314-3.068z",
    fill: "#ECEEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.091 303.8l-.384-.664-5.313 3.068.383.664.384.664 5.313-3.068-.383-.664zm-6.081 1.74l.384.664 5.313-3.068-.383-.664-.384-.664-5.313 3.067.383.665zm-.28 1.047l.664-.383-.384-.664-.383-.665a1.534 1.534 0 00-.561 2.096l.664-.384zm1.047.281l-.383-.664-.664.383-.664.384a1.533 1.533 0 002.095.561l-.384-.664zm5.594-4.115l-.664.383.384.664.383.664a1.532 1.532 0 00.561-2.095l-.664.384zm0 0l.664-.384a1.533 1.533 0 00-2.095-.561l.384.664.383.664.664-.383z",
    fill: "#C8CDD8",
    mask: "url(#m)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.881 304.191l-1.66.958h-.001.001l1.66-.958z",
    fill: "#C4CAD6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCD0DA",
    d: "M485.538 306.255l.384.664-3.32 1.917-.384-.664z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "n",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M479.369 309.374a.767.767 0 11.767 1.328l-5.313 3.068a.766.766 0 11-.767-1.328l5.313-3.068z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M479.369 309.374a.767.767 0 11.767 1.328l-5.313 3.068a.766.766 0 11-.767-1.328l5.313-3.068z",
    fill: "#ECEEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.136 310.702l-.384-.664-5.313 3.068.384.664.383.664 5.313-3.067-.383-.665zm-6.08 1.74l.383.664 5.313-3.068-.383-.664-.383-.664-5.314 3.067.384.665zm-.281 1.047l.664-.383-.383-.664-.384-.665a1.535 1.535 0 00-.561 2.096l.664-.384zm1.048.281l-.384-.664-.664.383-.664.384a1.534 1.534 0 002.095.561l-.383-.664zm5.594-4.115l-.665.383.384.664.383.665a1.535 1.535 0 00.562-2.096l-.664.384zm0 0l.664-.384a1.534 1.534 0 00-2.095-.561l.383.664.383.664.665-.383z",
    fill: "#C8CDD8",
    mask: "url(#n)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.926 311.093l-1.66.958 1.66-.958z",
    fill: "#C4CAD6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCD0DA",
    d: "M473.583 313.157l.384.664-3.32 1.917-.384-.664z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "o",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.414 316.276a.767.767 0 11.767 1.328l-5.313 3.068a.766.766 0 11-.767-1.328l5.313-3.068z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M467.414 316.276a.767.767 0 11.767 1.328l-5.313 3.068a.766.766 0 11-.767-1.328l5.313-3.068z",
    fill: "#ECEEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.181 317.604l-.384-.664-5.313 3.068.384.664.383.664 5.313-3.067-.383-.665zm-6.08 1.74l.383.664 5.313-3.068-.383-.664-.383-.664-5.314 3.068.384.664zm-.281 1.047l.664-.383-.383-.664-.384-.664a1.533 1.533 0 00-.561 2.095l.664-.384zm1.048.281l-.384-.664-.664.383-.664.384a1.533 1.533 0 002.095.561l-.383-.664zm5.594-4.115l-.665.383.384.664.383.665a1.535 1.535 0 00.562-2.096l-.664.384zm0 0l.664-.384a1.534 1.534 0 00-2.095-.561l.383.664.383.664.665-.383z",
    fill: "#C8CDD8",
    mask: "url(#o)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.971 317.995l-1.66.958 1.66-.958z",
    fill: "#C4CAD6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCD0DA",
    d: "M461.628 320.059l.384.664-3.32 1.917-.384-.664z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "p",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M455.459 323.178a.767.767 0 11.767 1.329l-5.313 3.067a.767.767 0 01-.767-1.328l5.313-3.068z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M455.459 323.178a.767.767 0 11.767 1.329l-5.313 3.067a.767.767 0 01-.767-1.328l5.313-3.068z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.226 324.507l-.383-.665-5.313 3.068.383.664.383.664 5.314-3.067-.384-.664zm-6.08 1.739l.384.664 5.313-3.068-.384-.664-.383-.664-5.313 3.068.383.664zm-.281 1.047l.665-.383-.384-.664-.383-.664a1.534 1.534 0 00-.562 2.095l.664-.384zm1.048.281l-.383-.664-.665.383-.664.384a1.533 1.533 0 002.095.561l-.383-.664zm5.594-4.115l-.664.383.383.665.384.664a1.534 1.534 0 00.561-2.095l-.664.383zm0 0l.664-.383a1.534 1.534 0 00-2.095-.562l.383.664.384.664.664-.383z",
    fill: "#C8CDD8",
    mask: "url(#p)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.017 324.897l-1.661.959v-.001l1.661-.958z",
    fill: "#C4CAD6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCD0DA",
    d: "M449.674 326.961l.384.664-3.32 1.917-.384-.664z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "q",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443.736 329.947a.5.5 0 01.683.183l.267.462a.5.5 0 01-.866.5l-.267-.462a.5.5 0 01.183-.683z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M443.736 329.947a.5.5 0 01.683.183l.267.462a.5.5 0 01-.866.5l-.267-.462a.5.5 0 01.183-.683z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.419 330.13l-.664.383.267.463.664-.384.664-.383-.267-.463-.664.384zm-.599.962l.664-.383-.267-.463-.664.384-.664.383.267.463.664-.384zm-.267-.462l.664-.384a.267.267 0 01-.098.365l-.383-.664-.384-.664a1.267 1.267 0 00-.463 1.73l.664-.383zm.95.645l-.384-.664a.267.267 0 01.365.098l-.664.383-.664.384c.35.606 1.124.813 1.73.463l-.383-.664zm.183-.683l-.664.384a.267.267 0 01.097-.365l.384.664.383.664a1.266 1.266 0 00.464-1.73l-.664.383zm-.267-.462l.664-.384a1.268 1.268 0 00-1.731-.463l.384.664.383.664a.266.266 0 01-.364-.098l.664-.383z",
    fill: "#C8CDD8",
    mask: "url(#q)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.95 330.132l-1.661.958 1.661-.958z",
    fill: "#C4CAD6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CCD0DA",
    d: "M443.495 330.529l.384.664-3.32 1.917-.384-.664z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "r",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.646 331.731a.768.768 0 01.767 1.328l-5.313 3.068a.767.767 0 11-.767-1.329l5.313-3.067z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M440.646 331.731a.768.768 0 01.767 1.328l-5.313 3.068a.767.767 0 11-.767-1.329l5.313-3.067z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.413 333.059l-.384-.664-5.313 3.067.384.665.383.664 5.313-3.068-.383-.664zm-6.08 1.739l.383.664 5.313-3.067-.383-.664-.384-.664-5.313 3.067.384.664zm-.281 1.048l.664-.384-.383-.664-.384-.664a1.534 1.534 0 00-.561 2.095l.664-.383zm1.048.281l-.384-.665-.664.384-.664.383a1.534 1.534 0 002.095.562l-.383-.664zm5.594-4.116l-.665.384.384.664.383.664a1.534 1.534 0 00.562-2.095l-.664.383zm0 0l.664-.383a1.534 1.534 0 00-2.096-.561l.384.664.383.664.665-.384z",
    fill: "#C8CDD8",
    mask: "url(#r)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.203 333.449l-1.66.959 1.66-.959z",
    fill: "#C4CAD6"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "s",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.911 342.734h99.697v41.413h-99.697v-41.413z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M428.911 342.734v.767h99.697v-1.534h-99.697v.767z",
    fill: "#E8EAF0",
    mask: "url(#s)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.911 350.787a1.15 1.15 0 011.15-1.151h32.593a1.15 1.15 0 110 2.301h-32.593a1.15 1.15 0 01-1.15-1.15z",
    fill: "#BCC2CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.911 370.271a1.15 1.15 0 011.15-1.151h4.907c.635 0 1.15.515 1.15 1.151v12.342h-7.207v-12.342z",
    fill: "#B8BFCE",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.186 365.358a1.15 1.15 0 011.15-1.151h4.907a1.15 1.15 0 011.151 1.151v17.255h-7.208v-17.255z",
    fill: "#CCD0DA",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.461 373.949c0-.635.515-1.15 1.15-1.15h4.907a1.15 1.15 0 011.151 1.15v8.664h-7.208v-8.664z",
    fill: "#DDE0E8",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.736 361.679c0-.635.515-1.15 1.151-1.15h4.907c.635 0 1.15.515 1.15 1.15v20.934h-7.208v-20.934z",
    fill: "#B8BFCE",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.012 367.814c0-.635.515-1.15 1.15-1.15h4.907c.635 0 1.15.515 1.15 1.15v14.799h-7.207v-14.799z",
    fill: "#CCD0DA",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.287 371.493c0-.635.515-1.15 1.15-1.15h4.907a1.15 1.15 0 011.151 1.15v11.12h-7.208v-11.12z",
    fill: "#DDE0E8",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.562 364.135c0-.635.515-1.15 1.15-1.15h4.907a1.15 1.15 0 011.151 1.15v18.478h-7.208v-18.478z",
    fill: "#B8BFCE",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.837 372.721c0-.635.515-1.15 1.151-1.15h4.907c.635 0 1.15.515 1.15 1.15v9.892h-7.208v-9.892z",
    fill: "#CCD0DA",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.113 366.586c0-.635.515-1.15 1.15-1.15h4.907c.635 0 1.15.515 1.15 1.15v16.027h-7.207v-16.027z",
    fill: "#DDE0E8",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.388 369.042c0-.635.515-1.15 1.151-1.15h4.906a1.15 1.15 0 011.151 1.15v13.571h-7.208v-13.571z",
    fill: "#B8BFCE",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5D9E3",
    d: "M428.911 383.38h99.697v.767h-99.697z"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M426.329 400.184c0 2.027-.702 3.04-2.105 3.04-.881 0-1.474-.329-1.778-.988h-.027c.014.029.021.326.021.892v2.272h-.972v-6.891c0-.609-.01-1.01-.032-1.203h.94c.004.014.009.068.016.161.007.089.014.223.022.403.01.175.016.306.016.392h.021c.179-.376.407-.649.682-.817.28-.172.643-.258 1.091-.258.709 0 1.237.246 1.584.736.347.487.521 1.241.521 2.261zm-.999 0c0-.809-.109-1.385-.328-1.729-.218-.347-.562-.521-1.031-.521-.54 0-.931.197-1.171.591-.24.39-.36.983-.36 1.778 0 .762.12 1.321.36 1.675.24.355.627.532 1.16.532.477 0 .824-.181 1.042-.542.219-.362.328-.956.328-1.784zm5.265 5.21c-.601 0-1.085-.123-1.45-.37s-.598-.602-.698-1.064l.988-.134c.061.269.192.474.392.618.204.147.471.22.8.22.888 0 1.332-.564 1.332-1.692v-1.042h-.01a1.912 1.912 0 01-.731.838c-.311.19-.682.285-1.112.285-.709 0-1.228-.231-1.557-.693-.326-.466-.489-1.196-.489-2.192 0-1.013.175-1.758.526-2.234.351-.48.892-.72 1.622-.72.405 0 .756.095 1.053.285.301.186.532.453.693.8h.016c0-.107.007-.288.022-.542.014-.258.028-.408.043-.451h.918c-.021.193-.032.594-.032 1.203v4.436c0 .813-.19 1.424-.569 1.832-.38.412-.965.617-1.757.617zm1.364-5.236c0-.691-.134-1.234-.402-1.628-.269-.397-.638-.596-1.107-.596-.49 0-.845.172-1.063.516-.219.34-.328.909-.328 1.708 0 .54.045.968.134 1.283.093.312.237.539.43.682.193.144.464.215.811.215.304 0 .571-.084.8-.252.233-.172.412-.421.537-.747.126-.329.188-.723.188-1.181zm4.814 2.959v-1.606h1.263v1.606h-1.263zm16.858-2.395c0 .759-.219 1.366-.656 1.82-.433.455-1.029.682-1.788.682-.845 0-1.495-.307-1.95-.923-.455-.62-.682-1.497-.682-2.632 0-1.246.236-2.209.709-2.89.473-.68 1.139-1.02 1.998-1.02 1.142 0 1.862.514 2.159 1.541l-.924.167c-.189-.616-.605-.924-1.246-.924-.548 0-.974.249-1.278.746-.304.498-.457 1.196-.457 2.095.176-.326.423-.573.742-.741a2.268 2.268 0 011.095-.258c.688 0 1.239.213 1.655.639.415.423.623.989.623 1.698zm-.983.043c0-.516-.138-.917-.414-1.204-.272-.286-.643-.429-1.112-.429a1.63 1.63 0 00-.752.182 1.372 1.372 0 00-.558.5 1.321 1.321 0 00-.199.72c0 .544.143.999.43 1.364.29.365.66.548 1.112.548.454 0 .816-.151 1.085-.451.272-.301.408-.711.408-1.23zm2.826-.07v-.736h4.77v.736h-4.77zm11.646-4.077c-1.693 2.435-2.54 4.601-2.54 6.499h-1.01c0-.942.218-1.957.655-3.045.441-1.092 1.094-2.233 1.961-3.422h-3.959v-.779h4.893v.747z",
    fill: "#7B5EA7"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_dd_2012_6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "t",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.338 449.845a4.601 4.601 0 014.601-4.601h107.366a4.601 4.601 0 014.602 4.601v116.569a4.601 4.601 0 01-4.602 4.601H103.939a4.601 4.601 0 01-4.601-4.601V449.845z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99.338 449.845a4.601 4.601 0 014.601-4.601h107.366a4.601 4.601 0 014.602 4.601v116.569a4.601 4.601 0 01-4.602 4.601H103.939a4.601 4.601 0 01-4.601-4.601V449.845z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.338 449.845a4.601 4.601 0 014.601-4.601h107.366a4.601 4.601 0 014.602 4.601v116.569a4.601 4.601 0 01-4.602 4.601H103.939a4.601 4.601 0 01-4.601-4.601V449.845z",
    fill: "url(#paint15_linear_2012_6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.939 445.244v.766h107.366v-1.533H103.939v.767zm111.968 4.601h-.767v116.569h1.534V449.845h-.767zm-4.602 121.17v-.767H103.939v1.534h107.366v-.767zm-111.967-4.601h.767V449.845h-1.534v116.569h.767zm4.601 4.601v-.767a3.835 3.835 0 01-3.834-3.834h-1.534a5.368 5.368 0 005.368 5.368v-.767zm111.968-4.601h-.767a3.835 3.835 0 01-3.835 3.834v1.534a5.368 5.368 0 005.369-5.368h-.767zm-4.602-121.17v.766a3.835 3.835 0 013.835 3.835h1.534a5.368 5.368 0 00-5.369-5.368v.767zm-107.366 0v-.767a5.368 5.368 0 00-5.368 5.368h1.534a3.835 3.835 0 013.834-3.835v-.766z",
    fill: "#E4E7EE",
    mask: "url(#t)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.774 454.83c0-.847.687-1.534 1.534-1.534h51.766a1.534 1.534 0 010 3.068h-51.766a1.534 1.534 0 01-1.534-1.534z",
    fill: "#A8AFC0"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "u",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.774 465.567a3.068 3.068 0 013.068-3.068h93.562a3.067 3.067 0 013.067 3.068v39.878a3.067 3.067 0 01-3.067 3.068h-93.562a3.068 3.068 0 01-3.068-3.068v-39.878z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M107.774 465.567a3.068 3.068 0 013.068-3.068h93.562a3.067 3.067 0 013.067 3.068v39.878a3.067 3.067 0 01-3.067 3.068h-93.562a3.068 3.068 0 01-3.068-3.068v-39.878z",
    fill: "#ECEEF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.842 462.499v.767h93.562v-1.534h-93.562v.767zm96.629 3.068h-.767v39.878h1.534v-39.878h-.767zm-3.067 42.946v-.767h-93.562v1.534h93.562v-.767zm-96.63-3.068h.767v-39.878h-1.533v39.878h.766zm3.068 3.068v-.767a2.3 2.3 0 01-2.301-2.301h-1.533a3.834 3.834 0 003.834 3.835v-.767zm96.629-3.068h-.767a2.3 2.3 0 01-2.3 2.301v1.534a3.834 3.834 0 003.834-3.835h-.767zm-3.067-42.946v.767a2.3 2.3 0 012.3 2.301h1.534a3.834 3.834 0 00-3.834-3.835v.767zm-93.562 0v-.767a3.834 3.834 0 00-3.834 3.835h1.533a2.3 2.3 0 012.301-2.301v-.767z",
    fill: "#E0E3EA",
    mask: "url(#u)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_2012_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.909 478.221h-14.571c-.848 0-1.534.687-1.534 1.534v11.503c0 .847.686 1.534 1.534 1.534h14.571c.847 0 1.533-.687 1.533-1.534v-11.503c0-.847-.686-1.534-1.533-1.534z",
    stroke: "#BCC2CF",
    strokeWidth: 0.614
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.555 485.123a1.918 1.918 0 10.001-3.835 1.918 1.918 0 00-.001 3.835z",
    fill: "#DDE0E8",
    stroke: "#BCC2CF",
    strokeWidth: 0.537
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.187 490.108l4.601-4.602 3.068 3.068 3.835-4.601 5.368 6.135",
    fill: "#E8EAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.187 490.108l4.601-4.602 3.068 3.068 3.835-4.601 5.368 6.135",
    stroke: "#BCC2CF",
    strokeWidth: 0.614
  })), /*#__PURE__*/React.createElement("path", {
    d: "M107.775 517.332c0-.635.515-1.15 1.15-1.15h85.432a1.15 1.15 0 010 2.3h-85.432a1.15 1.15 0 01-1.15-1.15zm0 4.985c0-.635.515-1.15 1.15-1.15h69.477a1.15 1.15 0 010 2.3h-69.477a1.15 1.15 0 01-1.15-1.15zm0 4.985a1.15 1.15 0 011.15-1.151h92.412a1.15 1.15 0 010 2.301h-92.412a1.15 1.15 0 01-1.15-1.15zm0 4.985a1.15 1.15 0 011.15-1.151h57.518a1.15 1.15 0 010 2.301h-57.518a1.15 1.15 0 01-1.15-1.15zm0 4.984c0-.635.515-1.15 1.15-1.15h79.447a1.15 1.15 0 010 2.301h-79.447a1.15 1.15 0 01-1.15-1.151zm0 4.985c0-.635.515-1.15 1.15-1.15h75.462a1.15 1.15 0 110 2.301h-75.462a1.15 1.15 0 01-1.15-1.151zm0 4.985c0-.635.515-1.15 1.15-1.15h87.427a1.15 1.15 0 010 2.3h-87.427a1.15 1.15 0 01-1.15-1.15zm0 4.985c0-.635.515-1.15 1.15-1.15h52.533a1.15 1.15 0 010 2.3h-52.533a1.15 1.15 0 01-1.15-1.15zm0 4.985a1.15 1.15 0 011.15-1.151h82.442a1.15 1.15 0 110 2.301h-82.441a1.15 1.15 0 01-1.151-1.15zm0 4.985a1.15 1.15 0 011.15-1.151h65.493a1.15 1.15 0 010 2.301h-65.493a1.15 1.15 0 01-1.15-1.15z",
    fill: "#D5D9E3",
    opacity: 0.55
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M105.193 581.3c0 2.027-.702 3.04-2.106 3.04-.88 0-1.473-.329-1.777-.988h-.027c.014.029.021.326.021.892v2.272h-.972v-6.892c0-.608-.011-1.009-.032-1.203h.94c.003.015.009.068.016.161.007.09.014.224.021.403.011.176.016.306.016.392h.022c.179-.376.406-.648.682-.816.279-.172.643-.258 1.09-.258.709 0 1.238.245 1.585.736.347.487.521 1.241.521 2.261zm-.999 0c0-.809-.109-1.386-.328-1.729-.218-.348-.562-.521-1.031-.521-.541 0-.931.197-1.171.591-.24.39-.36.982-.36 1.777 0 .763.12 1.322.36 1.676.24.355.627.532 1.16.532.476 0 .824-.181 1.042-.543.219-.361.328-.956.328-1.783zm5.265 5.21c-.602 0-1.085-.123-1.45-.37-.365-.248-.598-.602-.698-1.064l.988-.134a.996.996 0 00.392.617c.204.147.471.221.8.221.888 0 1.332-.564 1.332-1.692v-1.042h-.011a1.904 1.904 0 01-.73.838c-.312.189-.682.284-1.112.284-.709 0-1.228-.231-1.557-.693-.326-.465-.489-1.195-.489-2.191 0-1.013.175-1.758.526-2.234.351-.48.892-.72 1.622-.72.405 0 .756.095 1.053.285.301.186.532.453.693.8h.016c0-.108.007-.288.021-.543.015-.257.029-.408.043-.451h.919c-.022.194-.032.595-.032 1.203v4.437c0 .813-.19 1.423-.57 1.831-.379.412-.965.618-1.756.618zm1.364-5.237c0-.691-.134-1.233-.403-1.627-.268-.398-.637-.596-1.106-.596-.491 0-.845.172-1.064.515-.218.34-.327.91-.327 1.708 0 .541.045.969.134 1.284.093.312.236.539.43.682.193.143.463.215.811.215.304 0 .571-.084.8-.252.233-.172.412-.421.537-.747.126-.329.188-.723.188-1.182zm4.814 2.96v-1.606h1.262v1.606h-1.262zm16.847-2.03c0 .658-.224 1.179-.672 1.563-.444.383-1.079.574-1.906.574-.81 0-1.443-.188-1.902-.564-.455-.376-.682-.897-.682-1.563 0-.462.142-.854.424-1.176a1.796 1.796 0 011.085-.602v-.021a1.692 1.692 0 01-.966-.612 1.688 1.688 0 01-.366-1.069c0-.351.099-.67.296-.956.2-.287.481-.509.843-.666a3.087 3.087 0 011.246-.237c.491 0 .919.081 1.284.242.365.158.644.378.838.661.193.283.29.605.29.967 0 .404-.124.762-.371 1.074a1.594 1.594 0 01-.972.585v.022c.465.075.836.272 1.112.591.279.315.419.71.419 1.187zm-1.193-3.406c0-.397-.121-.696-.365-.897-.24-.204-.587-.306-1.042-.306-.44 0-.784.102-1.031.306-.244.204-.365.503-.365.897 0 .398.123.706.37.924.247.218.593.328 1.037.328.931 0 1.396-.417 1.396-1.252zm.188 3.314c0-.429-.139-.759-.419-.988-.279-.233-.671-.349-1.176-.349-.487 0-.87.125-1.149.376-.276.247-.414.574-.414.983 0 .483.134.852.403 1.106.272.251.67.376 1.192.376.527 0 .919-.123 1.177-.37.257-.248.386-.625.386-1.134zm2.859-.301v-.735h4.77v.735h-4.77zm11.743-1.353c0 1.239-.238 2.197-.715 2.873-.476.674-1.151 1.01-2.024 1.01-.591 0-1.066-.123-1.424-.37-.354-.251-.609-.654-.762-1.209l.923-.145c.194.63.62.945 1.279.945.551 0 .981-.248 1.289-.746.311-.501.471-1.193.478-2.073-.143.322-.389.581-.736.778-.347.194-.729.29-1.144.29-.677 0-1.221-.227-1.633-.682-.408-.458-.612-1.054-.612-1.788 0-.759.224-1.359.671-1.8.451-.444 1.067-.666 1.848-.666 1.708 0 2.562 1.195 2.562 3.583zm-1.053-.854c0-.577-.143-1.044-.43-1.402a1.351 1.351 0 00-1.111-.542c-.466 0-.833.155-1.101.467-.269.311-.403.716-.403 1.214 0 .512.134.925.403 1.24.268.312.632.468 1.09.468.272 0 .528-.061.768-.183a1.46 1.46 0 00.575-.516c.139-.222.209-.47.209-.746z",
    fill: "#9B6B2F"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_dd_2012_6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "v",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.907 449.845a4.601 4.601 0 014.601-4.601h107.366a4.602 4.602 0 014.602 4.601v116.569a4.602 4.602 0 01-4.602 4.601H264.508a4.601 4.601 0 01-4.601-4.601V449.845z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M259.907 449.845a4.601 4.601 0 014.601-4.601h107.366a4.602 4.602 0 014.602 4.601v116.569a4.602 4.602 0 01-4.602 4.601H264.508a4.601 4.601 0 01-4.601-4.601V449.845z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.907 449.845a4.601 4.601 0 014.601-4.601h107.366a4.602 4.602 0 014.602 4.601v116.569a4.602 4.602 0 01-4.602 4.601H264.508a4.601 4.601 0 01-4.601-4.601V449.845z",
    fill: "url(#paint16_linear_2012_6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.508 445.244v.766h107.366v-1.533H264.508v.767zm111.968 4.601h-.767v116.569h1.533V449.845h-.766zm-4.602 121.17v-.767H264.508v1.534h107.366v-.767zm-111.967-4.601h.767V449.845h-1.534v116.569h.767zm4.601 4.601v-.767a3.834 3.834 0 01-3.834-3.834h-1.534a5.368 5.368 0 005.368 5.368v-.767zm111.968-4.601h-.767a3.835 3.835 0 01-3.835 3.834v1.534a5.368 5.368 0 005.368-5.368h-.766zm-4.602-121.17v.766a3.835 3.835 0 013.835 3.835h1.533a5.368 5.368 0 00-5.368-5.368v.767zm-107.366 0v-.767a5.368 5.368 0 00-5.368 5.368h1.534a3.834 3.834 0 013.834-3.835v-.766z",
    fill: "#E4E7EE",
    mask: "url(#v)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.344 455.213c0-.847.686-1.534 1.534-1.534h46.78a1.534 1.534 0 110 3.068h-46.78a1.534 1.534 0 01-1.534-1.534z",
    fill: "#A8AFC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.344 460.965c0-.635.515-1.15 1.15-1.15h67.487a1.15 1.15 0 110 2.3h-67.487a1.15 1.15 0 01-1.15-1.15z",
    fill: "#D0D4DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.344 472.66c0-.741.601-1.342 1.342-1.342h37.194a1.342 1.342 0 110 2.684h-37.194a1.342 1.342 0 01-1.342-1.342z",
    fill: "#BCC2CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.344 481.288a1.15 1.15 0 011.15-1.151h79.248a1.15 1.15 0 110 2.301h-79.248a1.15 1.15 0 01-1.15-1.15z",
    fill: "#D5D9E3",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.028 481.288a1.15 1.15 0 011.15-1.151h9.712a1.15 1.15 0 110 2.301h-9.712a1.15 1.15 0 01-1.15-1.15z",
    fill: "#C4CAD6",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.344 486.656c0-.635.515-1.15 1.15-1.15h57.518a1.15 1.15 0 010 2.3h-57.518a1.15 1.15 0 01-1.15-1.15z",
    fill: "#D5D9E3",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.087 486.656c0-.635.515-1.15 1.15-1.15h11.654a1.15 1.15 0 010 2.3h-11.654a1.15 1.15 0 01-1.15-1.15z",
    fill: "#C4CAD6",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.344 492.024c0-.635.515-1.15 1.15-1.15h77.619a1.15 1.15 0 010 2.301h-77.619a1.15 1.15 0 01-1.15-1.151z",
    fill: "#D5D9E3",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.398 492.024c0-.635.515-1.15 1.151-1.15h11.342a1.15 1.15 0 010 2.301h-11.342a1.15 1.15 0 01-1.151-1.151z",
    fill: "#C4CAD6",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.344 497.393a1.15 1.15 0 011.15-1.151h75.462a1.15 1.15 0 010 2.301h-75.462a1.15 1.15 0 01-1.15-1.15z",
    fill: "#D5D9E3",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.087 497.393a1.15 1.15 0 011.15-1.151h11.654a1.15 1.15 0 010 2.301h-11.654a1.15 1.15 0 01-1.15-1.15z",
    fill: "#C4CAD6",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.344 502.761c0-.635.515-1.15 1.15-1.15h78.667a1.15 1.15 0 110 2.3h-78.667a1.15 1.15 0 01-1.15-1.15z",
    fill: "#D5D9E3",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.447 502.761c0-.635.515-1.15 1.15-1.15h10.293a1.15 1.15 0 110 2.3h-10.293a1.15 1.15 0 01-1.15-1.15z",
    fill: "#C4CAD6",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.344 508.129c0-.635.515-1.15 1.15-1.15h52.533a1.15 1.15 0 010 2.301h-52.533a1.15 1.15 0 01-1.15-1.151z",
    fill: "#D5D9E3",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.087 508.129c0-.635.515-1.15 1.15-1.15h11.654a1.15 1.15 0 010 2.301h-11.654a1.15 1.15 0 01-1.15-1.151z",
    fill: "#C4CAD6",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("mask", {
    id: "w",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.344 515.415h99.697v.767h-99.697v-.767z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M268.344 515.415v.767h99.697v-1.534h-99.697v.767z",
    fill: "#E0E3EA",
    mask: "url(#w)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.344 523.659c0-.741.601-1.342 1.342-1.342h27.225a1.342 1.342 0 010 2.684h-27.225a1.342 1.342 0 01-1.342-1.342z",
    fill: "#B0B7C6",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.092 523.659c0-.741.601-1.342 1.342-1.342h13.265a1.342 1.342 0 010 2.684h-13.265a1.342 1.342 0 01-1.342-1.342z",
    fill: "#A0A8B8",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.344 529.219c0-.635.515-1.15 1.15-1.15h72.472a1.15 1.15 0 010 2.3h-72.472a1.15 1.15 0 01-1.15-1.15z",
    fill: "#D5D9E3",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.082 529.219c0-.635.515-1.15 1.15-1.15h9.659a1.15 1.15 0 010 2.3h-9.659a1.15 1.15 0 01-1.15-1.15z",
    fill: "#C4CAD6",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.344 534.587c0-.635.515-1.15 1.15-1.15h80.255a1.15 1.15 0 010 2.301h-80.255a1.15 1.15 0 01-1.15-1.151z",
    fill: "#D5D9E3",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.035 534.587c0-.635.515-1.15 1.15-1.15h8.706a1.15 1.15 0 010 2.301h-8.706a1.15 1.15 0 01-1.15-1.151z",
    fill: "#C4CAD6",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.344 539.956a1.15 1.15 0 011.15-1.151h59.507a1.15 1.15 0 010 2.301h-59.507a1.15 1.15 0 01-1.15-1.15z",
    fill: "#D5D9E3",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.082 539.956a1.15 1.15 0 011.15-1.151h9.659a1.15 1.15 0 010 2.301h-9.659a1.15 1.15 0 01-1.15-1.15z",
    fill: "#C4CAD6",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.344 545.324c0-.635.515-1.15 1.15-1.15h79.692a1.15 1.15 0 010 2.3h-79.692a1.15 1.15 0 01-1.15-1.15z",
    fill: "#D5D9E3",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.471 545.324c0-.635.515-1.15 1.151-1.15h9.268a1.15 1.15 0 110 2.3h-9.268a1.15 1.15 0 01-1.151-1.15z",
    fill: "#C4CAD6",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("mask", {
    id: "x",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.344 552.609h99.697v6.902h-99.697v-6.902z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M268.344 552.609v.767h99.697v-1.534h-99.697v.767z",
    fill: "#BCC2CF",
    mask: "url(#x)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.344 557.978c0-.847.686-1.534 1.534-1.534h21.856a1.533 1.533 0 110 3.067h-21.856a1.533 1.533 0 01-1.534-1.533z",
    fill: "#A0A8B8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M332.541 559.978c1.944-4.347 4.537-5.071 6.481-2.174 1.944 2.898 3.889-2.173 6.481-.724 1.945 1.087 3.889-2.173 6.482-.724 2.593 1.448 5.185 2.897 7.778 1.448 1.944-1.086 3.889.725 7.778-.724",
    stroke: "#B3B9C6",
    strokeLinecap: "round"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M265.762 581.684c0 2.027-.702 3.04-2.106 3.04-.881 0-1.473-.329-1.778-.988h-.026c.014.029.021.326.021.892v2.272h-.972v-6.891c0-.609-.011-1.01-.032-1.203h.94c.003.014.009.068.016.161.007.089.014.223.021.403.011.175.016.306.016.392h.022c.179-.376.406-.649.682-.817.279-.172.643-.258 1.09-.258.709 0 1.237.246 1.585.736.347.487.521 1.241.521 2.261zm-.999 0c0-.809-.11-1.385-.328-1.729-.218-.347-.562-.521-1.031-.521-.541 0-.931.197-1.171.591-.24.39-.36.983-.36 1.778 0 .762.12 1.321.36 1.675.24.355.627.532 1.16.532.476 0 .824-.181 1.042-.542.218-.362.328-.956.328-1.784zm5.265 5.21c-.602 0-1.085-.123-1.45-.37-.366-.247-.598-.602-.699-1.064l.989-.134a.998.998 0 00.392.618c.204.147.471.22.8.22.888 0 1.332-.564 1.332-1.692v-1.042h-.011a1.91 1.91 0 01-.73.838c-.312.19-.682.285-1.112.285-.709 0-1.228-.231-1.558-.693-.325-.466-.488-1.196-.488-2.192 0-1.013.175-1.758.526-2.234.351-.48.892-.72 1.622-.72.405 0 .756.095 1.053.285.301.186.532.453.693.8h.016c0-.107.007-.288.021-.542.015-.258.029-.408.043-.451h.919c-.022.193-.033.594-.033 1.203v4.436c0 .813-.189 1.424-.569 1.832-.379.412-.965.617-1.756.617zm1.364-5.236c0-.691-.134-1.234-.403-1.628-.268-.397-.637-.596-1.106-.596-.491 0-.845.172-1.064.516-.218.34-.327.909-.327 1.708 0 .54.044.968.134 1.283.093.312.236.539.43.682.193.144.463.215.811.215.304 0 .571-.084.8-.252.233-.172.412-.421.537-.747.125-.329.188-.723.188-1.181zm4.814 2.959v-1.606h1.262v1.606h-1.262zm11.814 0v-.779h2.358v-5.484c-.133.28-.448.523-.946.731a3.743 3.743 0 01-1.46.311v-.795c.529 0 1.029-.116 1.498-.349.473-.232.802-.526.988-.881h.892v6.467h1.896v.779h-5.226zm11.898-3.625c0 1.21-.224 2.135-.671 2.776-.444.638-1.101.956-1.971.956-.87 0-1.524-.316-1.961-.95-.437-.638-.655-1.565-.655-2.782 0-1.25.213-2.185.639-2.804.426-.62 1.096-.929 2.009-.929.892 0 1.549.313 1.971.94.426.623.639 1.554.639 2.793zm-.983 0c0-1.039-.127-1.789-.381-2.251-.251-.465-.666-.698-1.246-.698-.594 0-1.022.229-1.284.687-.258.459-.387 1.212-.387 2.262 0 1.02.131 1.767.393 2.239.265.469.684.704 1.256.704.57 0 .987-.242 1.252-.725.265-.484.397-1.223.397-2.218zm-2.277.644v-1.337h1.262v1.337h-1.262z",
    fill: "#3D8B5E"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_dd_2012_6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_2012_6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "G",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.476 449.845a4.601 4.601 0 014.601-4.601h107.366a4.601 4.601 0 014.601 4.601v116.569a4.601 4.601 0 01-4.601 4.601H425.077a4.601 4.601 0 01-4.601-4.601V449.845z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M420.476 449.845a4.601 4.601 0 014.601-4.601h107.366a4.601 4.601 0 014.601 4.601v116.569a4.601 4.601 0 01-4.601 4.601H425.077a4.601 4.601 0 01-4.601-4.601V449.845z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.476 449.845a4.601 4.601 0 014.601-4.601h107.366a4.601 4.601 0 014.601 4.601v116.569a4.601 4.601 0 01-4.601 4.601H425.077a4.601 4.601 0 01-4.601-4.601V449.845z",
    fill: "url(#paint17_linear_2012_6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.912 454.83c0-.847.686-1.534 1.533-1.534h56.751a1.534 1.534 0 010 3.068h-56.751a1.533 1.533 0 01-1.533-1.534z",
    fill: "#A8AFC0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.912 466.717c0-.635.515-1.15 1.15-1.15h25.613a1.15 1.15 0 110 2.301h-25.613a1.15 1.15 0 01-1.15-1.151z",
    fill: "#B8BFCE",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("mask", {
    id: "y",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.912 471.702c0-.847.686-1.533 1.533-1.533h56.751c.847 0 1.534.686 1.534 1.533v3.068c0 .847-.687 1.534-1.534 1.534h-56.751a1.533 1.533 0 01-1.533-1.534v-3.068z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M428.912 471.702c0-.847.686-1.533 1.533-1.533h56.751c.847 0 1.534.686 1.534 1.533v3.068c0 .847-.687 1.534-1.534 1.534h-56.751a1.533 1.533 0 01-1.533-1.534v-3.068z",
    fill: "#F5F6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.445 470.169v.766h56.751v-1.533h-56.751v.767zm58.285 1.533h-.767v3.068h1.534v-3.068h-.767zm-1.534 4.602v-.767h-56.751v1.534h56.751v-.767zm-58.284-1.534h.767v-3.068h-1.534v3.068h.767zm1.533 1.534v-.767a.766.766 0 01-.766-.767h-1.534a2.3 2.3 0 002.3 2.301v-.767zm58.285-1.534h-.767a.766.766 0 01-.767.767v1.534a2.3 2.3 0 002.301-2.301h-.767zm-1.534-4.601v.766c.424 0 .767.344.767.767h1.534a2.3 2.3 0 00-2.301-2.3v.767zm-56.751 0v-.767a2.3 2.3 0 00-2.3 2.3h1.534c0-.423.343-.767.766-.767v-.766z",
    fill: "#D5D9E3",
    mask: "url(#y)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.912 482.055a1.15 1.15 0 011.15-1.151h19.628a1.15 1.15 0 010 2.301h-19.628a1.15 1.15 0 01-1.15-1.15z",
    fill: "#B8BFCE",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("mask", {
    id: "z",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.912 487.039c0-.847.686-1.533 1.533-1.533h46.781c.847 0 1.534.686 1.534 1.533v3.068c0 .847-.687 1.534-1.534 1.534h-46.781a1.533 1.533 0 01-1.533-1.534v-3.068z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M428.912 487.039c0-.847.686-1.533 1.533-1.533h46.781c.847 0 1.534.686 1.534 1.533v3.068c0 .847-.687 1.534-1.534 1.534h-46.781a1.533 1.533 0 01-1.533-1.534v-3.068z",
    fill: "#F5F6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.445 485.506v.767h46.781v-1.534h-46.781v.767zm48.315 1.533h-.767v3.068h1.534v-3.068h-.767zm-1.534 4.602v-.767h-46.781v1.534h46.781v-.767zm-48.314-1.534h.767v-3.068h-1.534v3.068h.767zm1.533 1.534v-.767a.766.766 0 01-.766-.767h-1.534a2.3 2.3 0 002.3 2.301v-.767zm48.315-1.534h-.767a.766.766 0 01-.767.767v1.534a2.3 2.3 0 002.301-2.301h-.767zm-1.534-4.601v.767c.424 0 .767.343.767.766h1.534a2.3 2.3 0 00-2.301-2.3v.767zm-46.781 0v-.767a2.3 2.3 0 00-2.3 2.3h1.534c0-.423.343-.766.766-.766v-.767z",
    fill: "#D5D9E3",
    mask: "url(#z)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.912 497.393a1.15 1.15 0 011.15-1.151h32.593a1.15 1.15 0 110 2.301h-32.593a1.15 1.15 0 01-1.15-1.15z",
    fill: "#B8BFCE",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("mask", {
    id: "A",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.912 502.378c0-.848.686-1.534 1.533-1.534h51.766c.847 0 1.534.686 1.534 1.534v3.067c0 .847-.687 1.534-1.534 1.534h-51.766a1.533 1.533 0 01-1.533-1.534v-3.067z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M428.912 502.378c0-.848.686-1.534 1.533-1.534h51.766c.847 0 1.534.686 1.534 1.534v3.067c0 .847-.687 1.534-1.534 1.534h-51.766a1.533 1.533 0 01-1.533-1.534v-3.067z",
    fill: "#F5F6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.445 500.844v.767h51.766v-1.534h-51.766v.767zm53.3 1.534h-.767v3.067h1.534v-3.067h-.767zm-1.534 4.601v-.767h-51.766v1.534h51.766v-.767zm-53.299-1.534h.767v-3.067h-1.534v3.067h.767zm1.533 1.534v-.767a.766.766 0 01-.766-.767h-1.534a2.3 2.3 0 002.3 2.301v-.767zm53.3-1.534h-.767a.766.766 0 01-.767.767v1.534a2.3 2.3 0 002.301-2.301h-.767zm-1.534-4.601v.767c.424 0 .767.343.767.767h1.534a2.3 2.3 0 00-2.301-2.301v.767zm-51.766 0v-.767a2.3 2.3 0 00-2.3 2.301h1.534c0-.424.343-.767.766-.767v-.767z",
    fill: "#D5D9E3",
    mask: "url(#A)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.912 512.731a1.15 1.15 0 011.15-1.151h17.639a1.15 1.15 0 010 2.301h-17.639a1.15 1.15 0 01-1.15-1.15z",
    fill: "#B8BFCE",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("mask", {
    id: "B",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.912 517.716c0-.848.686-1.534 1.533-1.534h66.721c.847 0 1.534.686 1.534 1.534v3.067c0 .847-.687 1.534-1.534 1.534h-66.721a1.533 1.533 0 01-1.533-1.534v-3.067z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M428.912 517.716c0-.848.686-1.534 1.533-1.534h66.721c.847 0 1.534.686 1.534 1.534v3.067c0 .847-.687 1.534-1.534 1.534h-66.721a1.533 1.533 0 01-1.533-1.534v-3.067z",
    fill: "#F5F6FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.445 516.182v.767h66.721v-1.534h-66.721v.767zm68.255 1.534h-.767v3.067h1.533v-3.067h-.766zm-1.534 4.601v-.767h-66.721v1.534h66.721v-.767zm-68.254-1.534h.767v-3.067h-1.534v3.067h.767zm1.533 1.534v-.767a.766.766 0 01-.766-.767h-1.534a2.3 2.3 0 002.3 2.301v-.767zm68.255-1.534h-.767a.767.767 0 01-.767.767v1.534a2.3 2.3 0 002.3-2.301h-.766zm-1.534-4.601v.767c.423 0 .767.343.767.767h1.533a2.3 2.3 0 00-2.3-2.301v.767zm-66.721 0v-.767a2.3 2.3 0 00-2.3 2.301h1.534c0-.424.343-.767.766-.767v-.767z",
    fill: "#D5D9E3",
    mask: "url(#B)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.912 529.602c0-.635.515-1.15 1.15-1.15h27.608a1.15 1.15 0 110 2.301h-27.608a1.15 1.15 0 01-1.15-1.151z",
    fill: "#B8BFCE",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("mask", {
    id: "C",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.912 534.971a1.15 1.15 0 011.15-1.151h2.301c.635 0 1.15.515 1.15 1.151v2.3a1.15 1.15 0 01-1.15 1.151h-2.301a1.15 1.15 0 01-1.15-1.151v-2.3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M428.912 534.971a1.15 1.15 0 011.15-1.151h2.301c.635 0 1.15.515 1.15 1.151v2.3a1.15 1.15 0 01-1.15 1.151h-2.301a1.15 1.15 0 01-1.15-1.151v-2.3z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.062 533.82v.767h2.301v-1.534h-2.301v.767zm3.451 1.151h-.767v2.3h1.534v-2.3h-.767zm-1.15 3.451v-.767h-2.301v1.533h2.301v-.766zm-3.451-1.151h.767v-2.3h-1.534v2.3h.767zm1.15 1.151v-.767a.383.383 0 01-.383-.384h-1.534c0 1.059.858 1.917 1.917 1.917v-.766zm3.451-1.151h-.767a.384.384 0 01-.383.384v1.533a1.917 1.917 0 001.917-1.917h-.767zm-1.15-3.451v.767c.211 0 .383.172.383.384h1.534a1.918 1.918 0 00-1.917-1.918v.767zm-2.301 0v-.767a1.918 1.918 0 00-1.917 1.918h1.534c0-.212.171-.384.383-.384v-.767z",
    fill: "#C4CAD6",
    mask: "url(#C)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.581 536.121c0-.53.429-.959.958-.959h42.947a.958.958 0 010 1.917h-42.947a.958.958 0 01-.958-.958z",
    fill: "#D5D9E3",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("mask", {
    id: "D",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.912 542.64a1.15 1.15 0 011.15-1.151h2.301c.635 0 1.15.515 1.15 1.151v2.3a1.15 1.15 0 01-1.15 1.151h-2.301a1.15 1.15 0 01-1.15-1.151v-2.3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M428.912 542.64a1.15 1.15 0 011.15-1.151h2.301c.635 0 1.15.515 1.15 1.151v2.3a1.15 1.15 0 01-1.15 1.151h-2.301a1.15 1.15 0 01-1.15-1.151v-2.3z",
    fill: "#D5D9E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.062 541.489v.767h2.301v-1.534h-2.301v.767zm3.451 1.151h-.767v2.3h1.534v-2.3h-.767zm-1.15 3.451v-.767h-2.301v1.534h2.301v-.767zm-3.451-1.151h.767v-2.3h-1.534v2.3h.767zm1.15 1.151v-.767a.383.383 0 01-.383-.384h-1.534c0 1.059.858 1.918 1.917 1.918v-.767zm3.451-1.151h-.767a.384.384 0 01-.383.384v1.534a1.918 1.918 0 001.917-1.918h-.767zm-1.15-3.451v.767c.211 0 .383.172.383.384h1.534a1.918 1.918 0 00-1.917-1.918v.767zm-2.301 0v-.767a1.918 1.918 0 00-1.917 1.918h1.534c0-.212.171-.384.383-.384v-.767z",
    fill: "#C4CAD6",
    mask: "url(#D)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_2012_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M430.062 543.79l.766.767 1.534-1.534",
    stroke: "#8B95A8",
    strokeWidth: 0.46,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M436.581 543.79c0-.53.429-.959.958-.959h54.905a.96.96 0 010 1.918h-54.905a.959.959 0 01-.958-.959z",
    fill: "#D5D9E3",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("mask", {
    id: "E",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.912 550.309a1.15 1.15 0 011.15-1.151h2.301c.635 0 1.15.515 1.15 1.151v2.3a1.15 1.15 0 01-1.15 1.151h-2.301a1.15 1.15 0 01-1.15-1.151v-2.3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M428.912 550.309a1.15 1.15 0 011.15-1.151h2.301c.635 0 1.15.515 1.15 1.151v2.3a1.15 1.15 0 01-1.15 1.151h-2.301a1.15 1.15 0 01-1.15-1.151v-2.3z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.062 549.158v.767h2.301v-1.534h-2.301v.767zm3.451 1.151h-.767v2.3h1.534v-2.3h-.767zm-1.15 3.451v-.767h-2.301v1.534h2.301v-.767zm-3.451-1.151h.767v-2.3h-1.534v2.3h.767zm1.15 1.151v-.767a.383.383 0 01-.383-.384h-1.534c0 1.059.858 1.918 1.917 1.918v-.767zm3.451-1.151h-.767a.384.384 0 01-.383.384v1.534a1.918 1.918 0 001.917-1.918h-.767zm-1.15-3.451v.767c.211 0 .383.172.383.384h1.534a1.918 1.918 0 00-1.917-1.918v.767zm-2.301 0v-.767a1.918 1.918 0 00-1.917 1.918h1.534c0-.212.171-.384.383-.384v-.767z",
    fill: "#C4CAD6",
    mask: "url(#E)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.581 551.459c0-.53.429-.959.958-.959h66.87a.958.958 0 110 1.917h-66.87a.958.958 0 01-.958-.958z",
    fill: "#D5D9E3",
    opacity: 0.55
  }), /*#__PURE__*/React.createElement("mask", {
    id: "F",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428.912 562.963h99.697v9.203h-99.697v-9.203z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M528.609 562.963v-.384h-.773v.767h.773v-.383zm-1.546 0v-.384h-1.546v.767h1.546v-.383zm-2.319 0v-.384h-1.545v.767h1.545v-.383zm-2.318 0v-.384h-1.546v.767h1.546v-.383zm-2.319 0v-.384h-1.545v.767h1.545v-.383zm-2.318 0v-.384h-1.546v.767h1.546v-.383zm-2.319 0v-.384h-1.545v.767h1.545v-.383zm-2.318 0v-.384h-1.546v.767h1.546v-.383zm-2.319 0v-.384h-1.546v.767h1.546v-.383zm-2.318 0v-.384h-1.546v.767h1.546v-.383zm-2.319 0v-.384h-1.546v.767h1.546v-.383zm-2.318 0v-.384h-1.546v.767h1.546v-.383zm-2.319 0v-.384h-1.546v.767h1.546v-.383zm-2.319 0v-.384h-1.545v.767h1.545v-.383zm-2.318 0v-.384h-1.546v.767h1.546v-.383zm-2.319 0v-.384h-1.545v.767h1.545v-.383zm-2.318 0v-.384h-1.546v.767h1.546v-.383zm-2.319 0v-.384h-1.545v.767h1.545v-.383zm-2.318 0v-.384h-1.546v.767h1.546v-.383zm-2.319 0v-.384h-1.545v.767h1.545v-.383zm-2.318 0v-.384h-1.546v.767h1.546v-.383zm-2.319 0v-.384h-1.545v.767h1.545v-.383zm-2.318 0v-.384h-1.546v.767h1.546v-.383zm-2.319 0v-.384h-1.546v.767h1.546v-.383zm-2.318 0v-.384h-1.546v.767h1.546v-.383zm-2.319 0v-.384h-1.546v.767h1.546v-.383zm-2.318 0v-.384h-1.546v.767h1.546v-.383zm-2.319 0v-.384h-1.546v.767h1.546v-.383zm-2.319 0v-.384h-1.545v.767h1.545v-.383zm-2.318 0v-.384h-1.546v.767h1.546v-.383zm-2.319 0v-.384h-1.545v.767h1.545v-.383zm-2.318 0v-.384h-1.546v.767h1.546v-.383zm-2.319 0v-.384h-1.545v.767h1.545v-.383zm-2.318 0v-.384h-1.546v.767h1.546v-.383zm-2.319 0v-.384h-1.545v.767h1.545v-.383zm-2.318 0v-.384h-1.546v.767h1.546v-.383zm-2.319 0v-.384h-1.545v.767h1.545v-.383zm-2.318 0v-.384h-1.546v.767h1.546v-.383zm-2.319 0v-.384h-1.546v.767h1.546v-.383zm-2.318 0v-.384h-1.546v.767h1.546v-.383zm-2.319 0v-.384h-1.546v.767h1.546v-.383zm-2.318 0v-.384h-1.546v.767h1.546v-.383zm-2.319 0v-.384h-1.546v.767h1.546v-.383zm-2.319 0v-.384h-.772v.767h.772v-.383zm98.925 0v-.767h-.773v1.534h.773v-.767zm-1.546 0v-.767h-1.546v1.534h1.546v-.767zm-2.319 0v-.767h-1.545v1.534h1.545v-.767zm-2.318 0v-.767h-1.546v1.534h1.546v-.767zm-2.319 0v-.767h-1.545v1.534h1.545v-.767zm-2.318 0v-.767h-1.546v1.534h1.546v-.767zm-2.319 0v-.767h-1.545v1.534h1.545v-.767zm-2.318 0v-.767h-1.546v1.534h1.546v-.767zm-2.319 0v-.767h-1.546v1.534h1.546v-.767zm-2.318 0v-.767h-1.546v1.534h1.546v-.767zm-2.319 0v-.767h-1.546v1.534h1.546v-.767zm-2.318 0v-.767h-1.546v1.534h1.546v-.767zm-2.319 0v-.767h-1.546v1.534h1.546v-.767zm-2.319 0v-.767h-1.545v1.534h1.545v-.767zm-2.318 0v-.767h-1.546v1.534h1.546v-.767zm-2.319 0v-.767h-1.545v1.534h1.545v-.767zm-2.318 0v-.767h-1.546v1.534h1.546v-.767zm-2.319 0v-.767h-1.545v1.534h1.545v-.767zm-2.318 0v-.767h-1.546v1.534h1.546v-.767zm-2.319 0v-.767h-1.545v1.534h1.545v-.767zm-2.318 0v-.767h-1.546v1.534h1.546v-.767zm-2.319 0v-.767h-1.545v1.534h1.545v-.767zm-2.318 0v-.767h-1.546v1.534h1.546v-.767zm-2.319 0v-.767h-1.546v1.534h1.546v-.767zm-2.318 0v-.767h-1.546v1.534h1.546v-.767zm-2.319 0v-.767h-1.546v1.534h1.546v-.767zm-2.318 0v-.767h-1.546v1.534h1.546v-.767zm-2.319 0v-.767h-1.546v1.534h1.546v-.767zm-2.319 0v-.767h-1.545v1.534h1.545v-.767zm-2.318 0v-.767h-1.546v1.534h1.546v-.767zm-2.319 0v-.767h-1.545v1.534h1.545v-.767zm-2.318 0v-.767h-1.546v1.534h1.546v-.767zm-2.319 0v-.767h-1.545v1.534h1.545v-.767zm-2.318 0v-.767h-1.546v1.534h1.546v-.767zm-2.319 0v-.767h-1.545v1.534h1.545v-.767zm-2.318 0v-.767h-1.546v1.534h1.546v-.767zm-2.319 0v-.767h-1.545v1.534h1.545v-.767zm-2.318 0v-.767h-1.546v1.534h1.546v-.767zm-2.319 0v-.767h-1.546v1.534h1.546v-.767zm-2.318 0v-.767h-1.546v1.534h1.546v-.767zm-2.319 0v-.767h-1.546v1.534h1.546v-.767zm-2.318 0v-.767h-1.546v1.534h1.546v-.767zm-2.319 0v-.767h-1.546v1.534h1.546v-.767zm-2.319 0v-.767h-.772v1.534h.772v-.767z",
    fill: "#D5D9E3",
    mask: "url(#F)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.912 571.015c0-.635.515-1.15 1.15-1.15h22.624a1.15 1.15 0 010 2.301h-22.624a1.15 1.15 0 01-1.15-1.151z",
    fill: "#C4CAD6",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M425.077 445.244v.766h107.366v-1.533H425.077v.767zm111.967 4.601h-.767v116.569h1.534V449.845h-.767zm-4.601 121.17v-.767H425.077v1.534h107.366v-.767zm-111.967-4.601h.766V449.845h-1.533v116.569h.767zm4.601 4.601v-.767a3.835 3.835 0 01-3.835-3.834h-1.533a5.368 5.368 0 005.368 5.368v-.767zm111.967-4.601h-.767a3.834 3.834 0 01-3.834 3.834v1.534a5.368 5.368 0 005.368-5.368h-.767zm-4.601-121.17v.766a3.834 3.834 0 013.834 3.835h1.534a5.368 5.368 0 00-5.368-5.368v.767zm-107.366 0v-.767a5.368 5.368 0 00-5.368 5.368h1.533a3.835 3.835 0 013.835-3.835v-.766z",
    fill: "#E4E7EE",
    mask: "url(#G)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M426.33 581.3c0 2.027-.702 3.04-2.106 3.04-.881 0-1.473-.329-1.778-.988h-.027c.015.029.022.326.022.892v2.272h-.972v-6.892c0-.608-.011-1.009-.032-1.203h.939c.004.015.009.068.017.161.007.09.014.224.021.403.011.176.016.306.016.392h.022c.179-.376.406-.648.682-.816.279-.172.643-.258 1.09-.258.709 0 1.237.245 1.585.736.347.487.521 1.241.521 2.261zm-.999 0c0-.809-.11-1.386-.328-1.729-.218-.348-.562-.521-1.031-.521-.541 0-.931.197-1.171.591-.24.39-.36.982-.36 1.777 0 .763.12 1.322.36 1.676.24.355.626.532 1.16.532.476 0 .824-.181 1.042-.543.218-.361.328-.956.328-1.783zm5.265 5.21c-.602 0-1.085-.123-1.451-.37-.365-.248-.598-.602-.698-1.064l.989-.134c.06.268.191.474.392.617.204.147.47.221.8.221.888 0 1.332-.564 1.332-1.692v-1.042h-.011a1.91 1.91 0 01-.73.838c-.312.189-.682.284-1.112.284-.709 0-1.228-.231-1.558-.693-.326-.465-.488-1.195-.488-2.191 0-1.013.175-1.758.526-2.234.351-.48.891-.72 1.622-.72.405 0 .755.095 1.053.285.3.186.531.453.693.8h.016c0-.108.007-.288.021-.543.014-.257.029-.408.043-.451h.919c-.022.194-.033.595-.033 1.203v4.437c0 .813-.189 1.423-.569 1.831-.38.412-.965.618-1.756.618zm1.364-5.237c0-.691-.134-1.233-.403-1.627-.268-.398-.637-.596-1.106-.596-.491 0-.845.172-1.064.515-.218.34-.327.91-.327 1.708 0 .541.044.969.134 1.284.093.312.236.539.429.682.194.143.464.215.812.215.304 0 .571-.084.8-.252.233-.172.412-.421.537-.747.125-.329.188-.723.188-1.182zm4.814 2.96v-1.606h1.262v1.606h-1.262zm11.814 0v-.779h2.358v-5.484c-.133.279-.448.523-.946.731a3.762 3.762 0 01-1.461.311v-.795c.53 0 1.03-.116 1.499-.349.473-.233.802-.526.988-.881h.892v6.467h1.896v.779h-5.226zm6.817 0v-.779h2.358v-5.484c-.133.279-.448.523-.945.731a3.762 3.762 0 01-1.461.311v-.795a3.32 3.32 0 001.498-.349c.473-.233.802-.526.989-.881h.891v6.467h1.896v.779h-5.226z",
    fill: "#7B5EA7"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "H",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.168 16.003a9.392 9.392 0 019.801-8.966l109.214 4.86a9.392 9.392 0 018.966 9.802l-5.667 127.345a9.394 9.394 0 01-9.801 8.966l-109.215-4.861a9.394 9.394 0 01-8.966-9.801l5.668-127.345z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M259.168 16.003a9.392 9.392 0 019.801-8.966l109.214 4.86a9.392 9.392 0 018.966 9.802l-5.667 127.345a9.394 9.394 0 01-9.801 8.966l-109.215-4.861a9.394 9.394 0 01-8.966-9.801l5.668-127.345z",
    fill: "#F3F4FA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M268.969 7.037l-.042.938 109.215 4.86.041-.937.042-.939L269.011 6.1l-.042.938zm118.18 14.662l-.938-.042-5.668 127.345.939.042.938.042 5.668-127.346-.939-.041zM371.681 158.01l.041-.939-109.214-4.86-.042.938-.042.938 109.215 4.861.042-.938zM253.5 143.348l.939.042 5.667-127.345-.938-.042-.939-.042-5.667 127.345.938.042zm8.966 9.801l.042-.938a8.453 8.453 0 01-8.069-8.821l-.939-.042-.938-.042c-.254 5.701 4.162 10.528 9.862 10.781l.042-.938zm119.016-4.105l-.939-.042a8.453 8.453 0 01-8.821 8.069l-.041.939-.042.938c5.7.254 10.527-4.162 10.781-9.862l-.938-.042zm-3.299-137.146l-.041.938a8.454 8.454 0 018.069 8.82l.938.043.939.041c.253-5.7-4.162-10.527-9.863-10.78l-.042.938zM268.969 7.037l.042-.938c-5.701-.254-10.528 4.161-10.782 9.862l.939.042.938.041a8.454 8.454 0 018.821-8.069l.042-.938z",
    fill: "#E0E4EE",
    mask: "url(#H)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "I",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.328 9.968a9.393 9.393 0 0110.584-8.027l108.305 14.877a9.392 9.392 0 018.027 10.584l-17.056 124.17a9.393 9.393 0 01-10.584 8.027l-108.306-14.878a9.392 9.392 0 01-8.027-10.583l17.057-124.17z"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M264.328 9.968a9.393 9.393 0 0110.584-8.027l108.305 14.877a9.392 9.392 0 018.027 10.584l-17.056 124.17a9.393 9.393 0 01-10.584 8.027l-108.306-14.878a9.392 9.392 0 01-8.027-10.583l17.057-124.17z",
    fill: "#F3F4FA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M274.912 1.94l-.128.931L383.09 17.75l.127-.93.128-.931L275.04 1.01l-.128.93zm116.332 25.462l-.93-.128-17.057 124.17.931.128.93.128 17.057-124.17-.931-.128zm-27.64 132.197l.128-.93-108.306-14.878-.128.93-.127.931 108.305 14.878.128-.931zm-116.333-25.461l.931.128 17.057-124.17-.931-.128-.93-.128-17.057 124.17.93.128zm8.027 10.583l.128-.93a8.453 8.453 0 01-7.224-9.525l-.931-.128-.93-.128c-.777 5.653 3.176 10.865 8.83 11.642l.127-.931zm118.89 6.851l-.931-.128a8.454 8.454 0 01-9.525 7.225l-.128.93-.128.931c5.653.776 10.865-3.177 11.642-8.83l-.93-.128zm9.029-134.754l-.127.93a8.454 8.454 0 017.224 9.526l.93.128.931.128c.777-5.653-3.177-10.866-8.83-11.642l-.128.93zM274.912 1.941l.128-.93c-5.653-.777-10.866 3.176-11.642 8.829l.93.128.931.128a8.453 8.453 0 019.525-7.225l.128-.93z",
    fill: "#E0E4EE",
    mask: "url(#I)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "J",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.262 8.357A9.392 9.392 0 01271.605.022l109.757 11.8c5.158.556 8.89 5.186 8.335 10.344l-13.513 125.679a9.392 9.392 0 01-10.343 8.335l-109.757-11.801a9.392 9.392 0 01-8.335-10.343l13.513-125.68z"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M261.262 8.357A9.392 9.392 0 01271.605.022l109.757 11.8c5.158.556 8.89 5.186 8.335 10.344l-13.513 125.679a9.392 9.392 0 01-10.343 8.335l-109.757-11.801a9.392 9.392 0 01-8.335-10.343l13.513-125.68z",
    fill: "#F3F4FA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M271.605.022l-.101.934 109.758 11.8.1-.933.101-.934-109.758-11.8-.1.933zm118.092 22.144l-.934-.1-13.513 125.679.934.1.934.101 13.513-125.68-.934-.1zM365.841 156.18l.101-.934-109.758-11.801-.1.934-.101.934 109.758 11.801.1-.934zm-118.092-22.144l.934.101 13.512-125.68-.933-.1-.934-.1-13.513 125.679.934.1zm8.335 10.343l.1-.934a8.453 8.453 0 01-7.501-9.308l-.934-.101-.934-.1c-.61 5.673 3.495 10.767 9.168 11.377l.101-.934zm120.1 3.466l-.934-.1a8.453 8.453 0 01-9.308 7.501l-.101.934-.1.934c5.673.61 10.767-3.495 11.377-9.168l-.934-.101zm5.178-136.022l-.1.934c4.642.499 8 4.667 7.501 9.309l.934.1.934.1c.61-5.673-3.495-10.767-9.168-11.377l-.101.934zM271.605.022l.1-.934c-5.674-.61-10.767 3.495-11.377 9.168l.934.1.933.101c.5-4.642 4.667-8 9.309-7.501l.101-.934z",
    fill: "#E0E4EE",
    mask: "url(#J)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "K",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.748 23.346a9.393 9.393 0 018.696-10.04l110.107-7.902a9.392 9.392 0 0110.041 8.696l8.972 125.015a9.393 9.393 0 01-8.696 10.041l-110.107 7.901a9.392 9.392 0 01-10.041-8.696l-8.972-125.014z"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M248.748 23.346a9.393 9.393 0 018.696-10.04l110.107-7.902a9.392 9.392 0 0110.041 8.696l8.972 125.015a9.393 9.393 0 01-8.696 10.041l-110.107 7.901a9.392 9.392 0 01-10.041-8.696l-8.972-125.014z",
    fill: "#F3F4FA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M257.444 13.305l.068.937L367.619 6.34l-.068-.936-.067-.937-110.107 7.902.067.936zm120.148.795l-.937.067 8.972 125.015.937-.067.937-.068-8.972-125.014-.937.067zm.276 135.056l-.068-.937-110.107 7.902.068.936.067.937 110.107-7.902-.067-.936zm-120.148-.795l.937-.067-8.972-125.015-.937.067-.937.068 8.972 125.014.937-.067zm10.041 8.696l-.068-.936a8.453 8.453 0 01-9.036-7.827l-.937.067-.937.067c.408 5.692 5.353 9.975 11.045 9.566l-.067-.937zm118.803-17.942l-.937.067a8.454 8.454 0 01-7.827 9.037l.068.937.067.936c5.692-.408 9.974-5.353 9.566-11.045l-.937.068zM367.551 5.404l.068.936a8.453 8.453 0 019.036 7.827l.937-.067.937-.067c-.408-5.692-5.353-9.975-11.045-9.566l.067.937zm-110.107 7.901l-.067-.936c-5.691.408-9.974 5.353-9.566 11.045l.937-.068.937-.067a8.454 8.454 0 017.827-9.037l-.068-.937z",
    fill: "#E0E4EE",
    mask: "url(#K)"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "L",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.405 18.201a9.392 9.392 0 018.975-9.792L368.6 3.66a9.394 9.394 0 019.792 8.976l5.446 125.218a9.394 9.394 0 01-8.976 9.792l-109.219 4.75c-5.183.225-9.567-3.793-9.792-8.976l-5.446-125.218z"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M250.405 18.201a9.392 9.392 0 018.975-9.792L368.6 3.66a9.394 9.394 0 019.792 8.976l5.446 125.218a9.394 9.394 0 01-8.976 9.792l-109.219 4.75c-5.183.225-9.567-3.793-9.792-8.976l-5.446-125.218z",
    fill: "#F3F4FA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M259.38 8.41l.041.938 109.22-4.75-.041-.939-.041-.938L259.34 7.47l.04.938zm119.012 4.225l-.939.04 5.446 125.219.939-.041.938-.041-5.446-125.218-.938.041zm-3.53 135.01l-.041-.939-109.219 4.751.041.938.04.938 109.22-4.75-.041-.938zm-119.011-4.226l.938-.041-5.446-125.217-.938.04-.939.041 5.446 125.218.939-.041zm9.792 8.976l-.041-.938a8.454 8.454 0 01-8.813-8.079l-.938.041-.939.041c.248 5.701 5.071 10.121 10.771 9.873l-.04-.938zm118.195-14.542l-.939.041a8.452 8.452 0 01-8.078 8.812l.041.939.041.938c5.701-.248 10.121-5.07 9.873-10.771l-.938.041zM368.6 3.659l.041.939a8.452 8.452 0 018.812 8.078l.939-.041.938-.04c-.248-5.702-5.07-10.122-10.771-9.874l.041.938zM259.38 8.41l-.04-.938c-5.701.248-10.122 5.07-9.874 10.771l.939-.04.938-.041a8.453 8.453 0 018.078-8.813l-.041-.939z",
    fill: "#E0E4EE",
    mask: "url(#L)"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_dd_2012_6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_2012_6)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "M",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.999 17.19a9.393 9.393 0 019.393-9.392h109.322a9.393 9.393 0 019.393 9.393v121.066a9.392 9.392 0 01-9.393 9.392H261.392a9.392 9.392 0 01-9.393-9.392V17.191z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M251.999 17.19a9.393 9.393 0 019.393-9.392h109.322a9.393 9.393 0 019.393 9.393v121.066a9.392 9.392 0 01-9.393 9.392H261.392a9.392 9.392 0 01-9.393-9.392V17.191z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.999 17.19a9.393 9.393 0 019.393-9.392h109.322a9.393 9.393 0 019.393 9.393v121.066a9.392 9.392 0 01-9.393 9.392H261.392a9.392 9.392 0 01-9.393-9.392V17.191z",
    fill: "url(#paint18_linear_2012_6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.211 21.925c0-1.179.956-2.135 2.136-2.135h72.594a2.135 2.135 0 010 4.27h-72.594a2.135 2.135 0 01-2.136-2.135z",
    fill: "#BFC6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.211 31c0-.884.717-1.601 1.602-1.601h48.04a1.601 1.601 0 110 3.203h-48.04A1.601 1.601 0 01264.211 31z",
    fill: "#D5D9E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.212 44.661c0-.884.717-1.601 1.601-1.601h97.149a1.601 1.601 0 010 3.203h-97.149a1.601 1.601 0 01-1.601-1.602zm0 5.339c0-.885.717-1.602 1.601-1.602h79a1.601 1.601 0 110 3.203h-79a1.601 1.601 0 01-1.601-1.602zm0 5.336c0-.884.717-1.601 1.601-1.601h99.284a1.601 1.601 0 010 3.203h-99.284a1.601 1.601 0 01-1.601-1.602zm0 5.872c0-.59.478-1.067 1.067-1.067h72.595a1.068 1.068 0 110 2.135h-72.595a1.067 1.067 0 01-1.067-1.068zm0 5.872c0-.884.717-1.601 1.601-1.601h89.676a1.601 1.601 0 010 3.203h-89.676a1.601 1.601 0 01-1.601-1.602zm0 5.338c0-.884.717-1.601 1.601-1.601h85.406a1.601 1.601 0 010 3.203h-85.406a1.601 1.601 0 01-1.601-1.602z",
    fill: "#DDE0EA",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.212 81.74c0-.885.717-1.602 1.602-1.602h73.662a1.601 1.601 0 010 3.203h-73.662a1.601 1.601 0 01-1.602-1.601z",
    fill: "#BFC6D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.212 90.28a1.6 1.6 0 011.602-1.6h48.04a1.601 1.601 0 110 3.203h-48.04a1.601 1.601 0 01-1.602-1.602z",
    fill: "#D5D9E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.213 105.01c0-.884.717-1.601 1.601-1.601h97.149a1.601 1.601 0 010 3.203h-97.149a1.601 1.601 0 01-1.601-1.602zm0 5.871c0-.59.478-1.068 1.067-1.068h80.068a1.068 1.068 0 110 2.135H265.28a1.067 1.067 0 01-1.067-1.067zm0 5.871c0-.884.717-1.601 1.601-1.601h99.284a1.601 1.601 0 010 3.203h-99.284a1.601 1.601 0 01-1.601-1.602zm0 5.339c0-.884.717-1.601 1.601-1.601h71.527a1.602 1.602 0 110 3.203h-71.527a1.601 1.601 0 01-1.601-1.602zm0 5.871c0-.59.478-1.068 1.067-1.068h90.744a1.067 1.067 0 010 2.135H265.28a1.067 1.067 0 01-1.067-1.067zm0 5.338c0-.59.478-1.068 1.067-1.068h86.473a1.068 1.068 0 110 2.135H265.28a1.067 1.067 0 01-1.067-1.067z",
    fill: "#DDE0EA",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    d: "M261.392 7.798v.94h109.322v-1.88H261.392v.94zm118.715 9.393h-.939v121.066h1.878V17.191h-.939zm-9.393 130.458v-.939H261.392v1.879h109.322v-.94zm-118.715-9.392h.939V17.191h-1.878v121.066h.939zm9.393 9.392v-.939a8.454 8.454 0 01-8.454-8.453h-1.878c0 5.706 4.626 10.332 10.332 10.332v-.94zm118.715-9.392h-.939a8.454 8.454 0 01-8.454 8.453v1.879c5.707 0 10.332-4.626 10.332-10.332h-.939zM370.714 7.798v.94a8.454 8.454 0 018.454 8.453h1.878c0-5.706-4.625-10.332-10.332-10.332v.94zm-109.322 0v-.94c-5.706 0-10.332 4.627-10.332 10.333h1.878a8.454 8.454 0 018.454-8.454v-.939z",
    fill: "#DDE2EE",
    mask: "url(#M)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_d_2012_6)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 268,
    y: 129,
    width: 95,
    height: 28,
    rx: 14,
    fill: "#fff",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.6,
    y: 129.6,
    width: 93.8,
    height: 26.8,
    rx: 13.4,
    stroke: "#E4E8F2",
    strokeWidth: 1.2,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.997 137.6h-6a1.2 1.2 0 00-1.2 1.2v8.4a1.2 1.2 0 001.2 1.2h6a1.2 1.2 0 001.2-1.2v-8.4a1.2 1.2 0 00-1.2-1.2z",
    stroke: "#8B95A8",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.197 141.199h3.6m-3.6 1.8h3m-3 1.8h3.6",
    stroke: "#8B95A8",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.843 138.774v8.727h-1.581v-7.188h-.051l-2.041 1.304v-1.449l2.169-1.394h1.504zm5.765 0v8.727h-1.58v-7.188h-.052l-2.041 1.304v-1.449l2.169-1.394h1.504zm5.21 11.182v-9h1.517v1.082h.09c.079-.159.191-.328.336-.507.145-.182.341-.336.588-.464.247-.131.563-.196.946-.196.506 0 .962.129 1.368.388.409.255.733.635.972 1.137.241.5.362 1.114.362 1.841 0 .719-.118 1.33-.354 1.833-.236.502-.557.886-.963 1.15a2.476 2.476 0 01-1.38.397c-.375 0-.687-.063-.934-.188a1.894 1.894 0 01-.596-.452 2.89 2.89 0 01-.345-.507h-.064v3.486h-1.543zm1.513-5.727c0 .423.059.794.179 1.112.122.318.297.567.524.746.23.176.508.264.835.264.341 0 .627-.091.857-.273.23-.184.403-.436.52-.754.119-.321.179-.686.179-1.095 0-.407-.059-.767-.175-1.083a1.63 1.63 0 00-.52-.741c-.23-.179-.517-.269-.861-.269-.329 0-.609.087-.839.26-.23.174-.405.417-.524.729-.117.313-.175.68-.175 1.104zm7.871 3.405c-.415 0-.789-.074-1.121-.222a1.826 1.826 0 01-.784-.665c-.191-.292-.286-.653-.286-1.082 0-.37.068-.675.205-.916.136-.242.322-.435.558-.58.236-.145.501-.254.797-.328.298-.077.606-.132.925-.166.383-.04.694-.076.933-.107.238-.034.412-.085.52-.153.11-.071.166-.181.166-.328v-.026c0-.321-.095-.569-.286-.746-.19-.176-.464-.264-.822-.264-.378 0-.678.083-.899.247-.219.165-.367.36-.443.584l-1.441-.204a2.3 2.3 0 01.563-.998 2.46 2.46 0 01.959-.605 3.67 3.67 0 011.252-.204c.316 0 .63.037.942.111.313.073.598.196.857.366.258.168.466.396.622.686.159.29.238.652.238 1.087v4.38h-1.482v-.899h-.052a1.855 1.855 0 01-1.031.891c-.253.094-.55.141-.89.141zm.4-1.134c.31 0 .578-.061.805-.183.228-.125.402-.29.525-.495.125-.204.187-.427.187-.669v-.771a.72.72 0 01-.247.111 3.376 3.376 0 01-.384.089c-.142.026-.282.049-.421.069l-.363.051c-.23.031-.436.082-.618.153a1.036 1.036 0 00-.43.298.73.73 0 00-.158.486c0 .284.104.499.311.644.208.145.472.217.793.217zm7.453 3.592c-.554 0-1.03-.075-1.427-.225-.398-.148-.718-.347-.959-.597a2.063 2.063 0 01-.503-.831l1.389-.337c.063.128.154.255.273.38.119.127.28.233.481.315.205.085.462.128.772.128.437 0 .8-.107 1.086-.32.287-.21.431-.557.431-1.04v-1.24h-.077a2.17 2.17 0 01-.349.49 1.779 1.779 0 01-.601.422c-.247.114-.558.171-.933.171-.503 0-.959-.118-1.368-.354-.407-.239-.73-.594-.972-1.065-.239-.475-.358-1.069-.358-1.782 0-.718.119-1.325.358-1.819.242-.497.567-.874.976-1.129a2.504 2.504 0 011.368-.388c.383 0 .699.065.946.196.25.128.449.282.596.464.148.179.26.348.337.507h.085v-1.082h1.522v6.652c0 .56-.134 1.023-.401 1.389a2.403 2.403 0 01-1.095.823c-.463.181-.989.272-1.577.272zm.013-3.895c.327 0 .605-.079.835-.238a1.47 1.47 0 00.524-.686c.12-.299.179-.656.179-1.074 0-.412-.059-.773-.179-1.082a1.54 1.54 0 00-.52-.721c-.227-.173-.507-.26-.839-.26-.344 0-.631.09-.861.269-.23.179-.403.425-.52.737a3 3 0 00-.174 1.057c0 .4.058.751.174 1.052.12.299.294.532.524.699.233.165.519.247.857.247zm7.538 1.432c-.656 0-1.223-.136-1.7-.409a2.775 2.775 0 01-1.095-1.167c-.256-.506-.384-1.101-.384-1.786 0-.673.128-1.264.384-1.773a2.898 2.898 0 011.082-1.193c.463-.287 1.007-.43 1.632-.43.404 0 .784.065 1.142.196.361.128.679.327.955.596.278.27.497.614.656 1.032.159.414.239.909.239 1.483v.473h-5.365v-1.04h3.886a1.665 1.665 0 00-.192-.789 1.391 1.391 0 00-.524-.549 1.467 1.467 0 00-.775-.201c-.316 0-.593.077-.831.231-.239.15-.425.349-.559.596a1.73 1.73 0 00-.2.806v.907c0 .381.07.708.209.98.139.27.334.478.584.623.25.142.542.213.878.213.224 0 .427-.032.609-.094.182-.065.34-.161.473-.286a1.19 1.19 0 00.303-.464l1.44.162c-.091.38-.264.713-.52.997-.253.281-.577.5-.972.656-.394.154-.846.23-1.355.23zm9.389-4.943l-1.406.154a1.119 1.119 0 00-.209-.401 1.034 1.034 0 00-.392-.303 1.438 1.438 0 00-.605-.115c-.321 0-.591.07-.81.209-.216.139-.322.32-.319.541a.563.563 0 00.209.465c.144.119.383.217.715.294l1.117.239c.619.133 1.079.345 1.381.634.304.29.457.669.46 1.138a1.784 1.784 0 01-.362 1.091c-.236.313-.564.557-.985.733-.42.176-.903.264-1.449.264-.801 0-1.446-.167-1.934-.503a2.02 2.02 0 01-.874-1.41l1.504-.145c.069.296.213.519.435.669.222.151.51.226.865.226.367 0 .661-.075.882-.226.225-.15.337-.337.337-.558a.585.585 0 00-.217-.465c-.143-.122-.364-.216-.665-.281l-1.117-.234c-.628-.131-1.092-.351-1.393-.661-.301-.312-.45-.707-.448-1.184a1.683 1.683 0 01.329-1.049c.224-.298.535-.528.933-.69.4-.165.862-.247 1.385-.247.767 0 1.37.163 1.811.49.443.327.717.768.822 1.325z",
    fill: "#6B7A99"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2012_6",
    x1: 62.522,
    y1: 29.133,
    x2: 152.472,
    y2: 77.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2012_6",
    x1: 448.522,
    y1: 367.133,
    x2: 538.472,
    y2: 415.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2012_6",
    x1: 518.522,
    y1: 38.133,
    x2: 608.472,
    y2: 86.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2012_6",
    x1: 35.522,
    y1: 367.133,
    x2: 125.472,
    y2: 415.039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2012_6",
    x1: 279.5,
    y1: 177,
    x2: 279.5,
    y2: 203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#546FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D56CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2012_6",
    x1: 279.499,
    y1: 177.765,
    x2: 279.499,
    y2: 202.236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#546FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D56CC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2012_6",
    x1: 287.312,
    y1: 200.395,
    x2: 284.105,
    y2: 196.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2012_6",
    x1: 270.919,
    y1: 178.656,
    x2: 277.69,
    y2: 185.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#999",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2012_6",
    x1: 157.622,
    y1: 379.778,
    x2: 157.622,
    y2: 395.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#546FFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#546FFF",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2012_6",
    x1: 318.191,
    y1: 379.768,
    x2: 318.191,
    y2: 395.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#546FFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#546FFF",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2012_6",
    x1: 478.76,
    y1: 379.768,
    x2: 478.76,
    y2: 395.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#546FFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#546FFF",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2012_6",
    x1: 157.622,
    y1: 561.268,
    x2: 157.622,
    y2: 576.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#546FFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#546FFF",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2012_6",
    x1: 318.191,
    y1: 561.268,
    x2: 318.191,
    y2: 576.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#546FFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#546FFF",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2012_6",
    x1: 478.76,
    y1: 561.268,
    x2: 478.76,
    y2: 576.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#546FFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#546FFF",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2012_6",
    x1: 316.053,
    y1: 136.811,
    x2: 316.053,
    y2: 154.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#546FFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#546FFF",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_2012_6",
    x: 182,
    y: 147,
    width: 272,
    height: 94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.329412 0 0 0 0 0.435294 0 0 0 0 1 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2012_6",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.329412 0 0 0 0 0.435294 0 0 0 0 1 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow_2012_6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dig_2012_6",
    x: 182,
    y: 147,
    width: 272,
    height: 94,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.329412 0 0 0 0 0.435294 0 0 0 0 1 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2012_6",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.329412 0 0 0 0 0.435294 0 0 0 0 1 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow_2012_6"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "0.99900001287460327 0.99900001287460327",
    numOctaves: 3,
    seed: 4251
  }), /*#__PURE__*/React.createElement("feDisplacementMap", {
    in: "effect2_innerShadow_2012_6",
    scale: 24,
    xChannelSelector: "R",
    yChannelSelector: "G",
    result: "displacedImage"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect3_texture_2012_6"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "displacedImage"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dg_2012_6",
    x: 251.062,
    y: 171.719,
    width: 56.875,
    height: 56.875,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4.875,
    in: "SourceAlpha",
    result: "effect1_dropShadow_2012_6"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10.156
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.156
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.329412 0 0 0 0 0.435294 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2012_6",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "0.99900001287460327 0.99900001287460327",
    numOctaves: 3,
    seed: 8345
  }), /*#__PURE__*/React.createElement("feDisplacementMap", {
    in: "shape",
    scale: 3.801,
    xChannelSelector: "R",
    yChannelSelector: "G",
    result: "displacedImage"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect2_texture_2012_6"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "displacedImage"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_di_2012_6",
    x: 259.861,
    y: 171.075,
    width: 39.276,
    height: 39.276,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4.588,
    in: "SourceAlpha",
    result: "effect1_dropShadow_2012_6"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.713
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.995
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.329412 0 0 0 0 0.435294 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2012_6",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.95,
    dy: 0.95
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.594
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 0.987079 0 0 0 0 0.987079 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect2_innerShadow_2012_6"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_g_2012_6",
    x: 241.944,
    y: 388.19,
    width: 183.114,
    height: 201.621,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "0.99900001287460327 0.99900001287460327",
    numOctaves: 3,
    seed: 3917
  }), /*#__PURE__*/React.createElement("feDisplacementMap", {
    in: "shape",
    scale: 87.621,
    xChannelSelector: "R",
    yChannelSelector: "G",
    result: "displacedImage"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_texture_2012_6"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "displacedImage"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_g_2012_6",
    x: 50.005,
    y: 436.876,
    width: 150.989,
    height: 166.249,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "0.99900001287460327 0.99900001287460327",
    numOctaves: 3,
    seed: 3917
  }), /*#__PURE__*/React.createElement("feDisplacementMap", {
    in: "shape",
    scale: 72.249,
    xChannelSelector: "R",
    yChannelSelector: "G",
    result: "displacedImage"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_texture_2012_6"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "displacedImage"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_g_2012_6",
    x: 422.974,
    y: 431.033,
    width: 167.052,
    height: 183.935,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feTurbulence", {
    type: "fractalNoise",
    baseFrequency: "0.99900001287460327 0.99900001287460327",
    numOctaves: 3,
    seed: 3917
  }), /*#__PURE__*/React.createElement("feDisplacementMap", {
    in: "shape",
    scale: 79.935,
    xChannelSelector: "R",
    yChannelSelector: "G",
    result: "displacedImage"
  }), /*#__PURE__*/React.createElement("feMerge", {
    result: "effect1_texture_2012_6"
  }, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "displacedImage"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_dd_2012_6",
    x: 90.135,
    y: 256.203,
    width: 134.974,
    height: 144.049,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.534
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.601
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_6"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.767
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.534
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2012_6",
    result: "effect2_dropShadow_2012_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2012_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_dd_2012_6",
    x: 250.704,
    y: 256.075,
    width: 134.974,
    height: 144.177,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.534
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.601
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_6"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.767
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.534
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2012_6",
    result: "effect2_dropShadow_2012_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2012_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_dd_2012_6",
    x: 411.273,
    y: 256.075,
    width: 134.974,
    height: 144.177,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.534
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.601
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_6"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.767
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.534
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2012_6",
    result: "effect2_dropShadow_2012_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2012_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_dd_2012_6",
    x: 90.135,
    y: 437.575,
    width: 134.974,
    height: 144.177,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.534
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.601
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_6"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.767
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.534
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2012_6",
    result: "effect2_dropShadow_2012_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2012_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_dd_2012_6",
    x: 250.704,
    y: 437.575,
    width: 134.974,
    height: 144.177,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.534
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.601
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_6"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.767
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.534
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2012_6",
    result: "effect2_dropShadow_2012_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2012_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_dd_2012_6",
    x: 411.273,
    y: 437.575,
    width: 134.974,
    height: 144.177,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.534
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.601
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_6"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.767
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.534
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2012_6",
    result: "effect2_dropShadow_2012_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2012_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_dd_2012_6",
    x: 221.942,
    y: -16.623,
    width: 188.222,
    height: 199.965,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.879
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.757
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_6"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.636
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15.028
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.329412 0 0 0 0 0.435294 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_2012_6",
    result: "effect2_dropShadow_2012_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2012_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d_2012_6",
    x: 260.961,
    y: 123.721,
    width: 109.077,
    height: 42.077,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.76
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.519
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2012_6"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2012_6",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2012_6"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h636v588H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2012_6"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(139 128)",
    d: "M0 0h358v393H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2012_6"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(143 167)",
    d: "M0 0h171v222H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2012_6"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(314 167)",
    d: "M0 0h172v222H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_2012_6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 206,
    y: 167,
    width: 224,
    height: 46,
    rx: 14,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_2012_6"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(98.955 67.821 215.179)",
    d: "M0 0h20v20H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_2012_6"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(308.989 296.337)",
    d: "M0 0h18.406v15.338H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_2012_6"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(148.42 477.837)",
    d: "M0 0h18.406v15.338H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_2012_6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.476 449.845a4.601 4.601 0 014.601-4.601h107.366a4.601 4.601 0 014.601 4.601v116.569a4.601 4.601 0 01-4.601 4.601H425.077a4.601 4.601 0 01-4.601-4.601V449.845z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_2012_6"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(429.679 542.256)",
    d: "M0 0h3.068v3.068H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_2012_6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.999 17.19a9.393 9.393 0 019.393-9.392h109.322a9.393 9.393 0 019.393 9.393v121.066a9.392 9.392 0 01-9.393 9.392H261.392a9.392 9.392 0 01-9.393-9.392V17.191z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2012_6",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-29.393 445.82 3.524) scale(153.785 264.312)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2012_6",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-29.393 1283.165 -563.326) scale(153.785 264.312)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2012_6",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-29.393 690.977 -861.27) scale(153.785 264.312)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2012_6",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-29.393 1076.665 223.995) scale(153.785 264.312)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChunk);
export default __webpack_public_path__ + "static/media/chunk.34619fb56cfeae55549bf696e419ffbc.svg";
export { ForwardRef as ReactComponent };